import React from "react";
import claimList from "../views/Forms/Claim/claimList";

  export const bankData = () => [
    "7852-Alliance Finance Company PLC",
    "7463-Amana Bank",
    "7472-Axis Bank",
    "7010-Bank of Ceylon",
    "7481-Cargills Bank Limited",
    "8004-Central Bank of Sri Lanka",
    "7825-Central Finance PLC",
    "7047-Citi Bank",
    "7746-Citizen Development Business Finance PLC",
    "7056-Commercial Bank PLC",
    "7870-Commercial Credit & Finance PLC",
    "7807-Commercial Leasing & Finance",
    "7205-Deutsche Bank",
    "7454-DFCC Vardhana Bank Ltd",
    "7074-Habib Bank Ltd",
    "7083-Hatton National Bank PLC",
    "7737-HDFC Bank",
    "7092-Hongkong Shanghai Bank",
    "7384-ICICI Bank Ltd",
    "7108-Indian Bank",
    "7117-Indian Overseas Bank",
    "7834-Kanrich Finance Limited",
    "7861-Lanka Orix Finance PLC",
    "7773-LB Finance PLC",
    "7269-MCB Bank Ltd",
    "7913-Mercantile Investment and Finance PLC",
    "7898-Merchant Bank of Sri Lanka & Finance PLC",
    "7214-National Development Bank PLC",
    "7719-National Savings Bank",
    "7162-Nations Trust Bank PLC",
    "7311-Pan Asia Banking Corporation PLC",
    "7135-Peoples Bank",
    "7922-People's Leasing & Finance PLC",
    "7296-Public Bank",
    "7755-Regional Development Bank",
    "7278-Sampath Bank PLC",
    "7728-Sanasa Development Bank",
    "7782-Senkadagala Finance PLC",
    "7287-Seylan Bank PLC",
    "7038-Standard Chartered Bank",
    "7144-State Bank of India",
    "7764-State Mortgage & Investment Bank",
    "7302-Union Bank of Colombo PLC",
    "7816-Vallibel Finance PLC",
  ];

  export  const branchData = () => ({
    "7852-Alliance Finance Company PLC": [
      "Aluthgama-036",
      "Ambalanthota-022",
      "Ampara-034",
      "Anuradhapura-015",
      "Avissawella-025",
      "Batticaloa-007",
      "Chilaw-018",
      "Dambulla-029",
      "Embilipitiya-035",
      "Galewela-024",
      "Galle-004",
      "Gampaha-002",
      "Ganemulla-020",
      "Head Office-001",
      "Hingurakgoda-031",
      "Horana-010",
      "Ja-Ela-012",
      "Jaffna-008",
      "Kadawatha-028",
      "Kaduruwela-021",
      "Kalpitiya-026",
      "Kandy-013",
      "Kegalle-033",
      "Kelaniya-009",
      "Kilinochchi-017",
      "Kuliyapitiya-023",
      "Kurunegala-027",
      "Maharagama-011",
      "Malambe-032",
      "Matara-014",
      "Negombo-019",
      "Nuwara Eliya-030",
      "Puttalam-016",
      "Ratnapura-003",
      "Trincomalee-006",
      "Vavuniya-005",
    ],
    "7463-Amana Bank": [
      "Akkaraipattu-015",
      "Akurana-010",
      "Badulla-021",
      "Dehiwela-016",
      "Dematagoda-028",
      "Eravur-019",
      "Galle-008",
      "Gampola-011",
      "Head Office-001",
      "Kaduruwela-022",
      "Kalmunai-006",
      "Kalmunai Unity Square-026",
      "Kandy-003",
      "Kattankudy-004",
      "Kinniya-024",
      "Kirulapana-029",
      "Kuliyapitiya-018",
      "Kurunegala-014",
      "Ladies-005",
      "Mawanella-013",
      "Negombo-020",
      "Nintavur-017",
      "Oddamavadi-009",
      "Old Moor Street -027",
      "Pettah-002",
      "Puttalam-023",
      "Ratnapura-025",
      "Sammanthurai-012",
    ],
    "7463-Amana Bank": [
      "Akkaraipattu-015",
      "Akurana-010",
      "Badulla-021",
      "Dehiwela-016",
      "Dematagoda-028",
      "Eravur-019",
      "Galle-008",
      "Gampola-011",
      "Head Office-001",
      "Kaduruwela-022",
      "Kalmunai-006",
      "Kalmunai Unity Square-026",
      "Kandy-003",
      "Kattankudy-004",
      "Kinniya-024",
      "Kirulapana-029",
      "Kuliyapitiya-018",
      "Kurunegala-014",
      "Ladies-005",
      "Mawanella-013",
      "Negombo-020",
      "Nintavur-017",
      "Oddamavadi-009",
      "Old Moor Street -027",
      "Pettah-002",
      "Puttalam-023",
      "Ratnapura-025",
      "Sammanthurai-012",
    ],
    "7472-Axis Bank": ["Colombo-002"],
    "7010-Bank of Ceylon": [
      "Addalachchenai-448",
      "Adikarigama-487",
      "Agalawatta-657",
      "Agarapathana-488",
      "Ahangama-276",
      "Ahungalla-754",
      "Akkaraipattu-590",
      "Akurana-489",
      "Akuressa-613",
      "Aladeniya-812",
      "Alankerny-449",
      "Alaveddy-380",
      "Alawathugoda-768",
      "Alawwa-498",
      "Aluthgama-680",
      "Aluthkade-032",
      "Aluthwala-277",
      "Ambalangoda-047",
      "Ambalantota-537",
      "Ambanpola-329",
      "Ampara-021",
      "Anamaduwa-548",
      "Anawilundawa-330",
      "Andankulam-381",
      "Andiambalama-494",
      "Angunakolapelessa-774",
      "Ankumbura-490",
      "Anuradhapura-022",
      "Anuradhapura Bazzar-551",
      "Anuradhapura New Town-098",
      "Araiyampathy-451",
      "Aralaganwila-599",
      "Aranayake-566",
      "Asiri Central-713",
      "Atchuvely-778",
      "Athurugiriya-757",
      "Avissawella-530",
      "Ayagama-401",
      "Badalkumbura-540",
      "Baddegama-525",
      "Badulla-011",
      "Badulla City-729",
      "Baduraliya-662",
      "Bakamuna-652",
      "Balangoda-688",
      "Ballaketuwa-320",
      "Bambalapitiya-037",
      "Bandaragama-665",
      "Bandarawela-515",
      "Barawakumbura-278",
      "Batapola-522",
      "Battaramulla-679",
      "Batticaloa-012",
      "Batticaloa Town-452",
      "Batuwatte-708",
      "Beliatta-539",
      "Bentota-102",
      "Beruwala-058",
      "Bibile-579",
      "Bingiriya-554",
      "Biyagama-732",
      "BOC premier-788",
      "Bogahakumbura-699",
      "Bogaswewa-808",
      "Bogawantalawa-491",
      "Bokkawala-465",
      "Bombuwela-651",
      "Bopitiya-711",
      "Boragas-795",
      "Boralesgamuwa-646",
      "Borella  2nd-668",
      "Borella S/G-038",
      "Botanical Gardens Peradeniya-462",
      "Bulathkohupitiya-311",
      "Bulathsinhala-673",
      "Buttala-560",
      "Central Bus Stand-573",
      "Central Camp-811",
      "Central Office-015",
      "Central Super Market-672",
      "CEYBANK Credit card centre-731",
      "Chankanai-792",
      "Chavakachcheri-501",
      "Cheddikulam-382",
      "Chenkalady-630",
      "Chilaw-020",
      "China Bay-436",
      "Chunnakam-053",
      "City Office-001",
      "Corporate-660",
      "Corporate 2nd-822",
      "Court Complex Kandy-474",
      "Dalugama-715",
      "Dambadeniya-331",
      "Dambagalla-700",
      "Dambulla-576",
      "Dankotuwa-497",
      "Danture-466",
      "Daulagala-467",
      "Dedicated Economic Centre - Meegoda-567",
      "Dehiattakandiya-686",
      "Dehiowita-634",
      "Dehiwala-051",
      "Deiyandara-784",
      "Delft-383",
      "Delgoda-716",
      "Demanhandiya-717",
      "Dematagoda-561",
      "Deniyaya-528",
      "Deraniyagala-642",
      "Devinuwara-504",
      "Dharga Town-563",
      "Digana-273",
      "Digana Village-469",
      "Dikwella-592",
      "Divulapitiya-433",
      "Diyabeduma-388",
      "Diyasenpura-389",
      "Diyatalawa-260",
      "Dodangoda-293",
      "Doramadalawa-390",
      "Dummalasuriya-580",
      "Eastern University-437",
      "Eheliyagoda-057",
      "Elakanda-258",
      "Electronic Banking Unit-777",
      "Ella-701",
      "Elpitiya-619",
      "Embilipitiya-535",
      "Embilipitiya City-312",
      "Endana-313",
      "Enderamulla-674",
      "Eppawala-692",
      "Eravur-790",
      "Ethiliwewa-702",
      "Ethimale-810",
      "Ettampitiya-476",
      "Fifth City-060",
      "Fish Market Peliyagoda-718",
      "Galagedera-615",
      "Galaha-101",
      "Galamuna-391",
      "Galenbindunuwewa-122",
      "Galewela-432",
      "Galgamuwa-549",
      "Galigamuwa-314",
      "Galkiriyagama-653",
      "Galle Bazaar-089",
      "Galle Fort-003",
      "Galnewa-514",
      "Gampaha S/G-045",
      "Gampola-575",
      "Gampola City-470",
      "Ganemulla-720",
      "Geli Oya-524",
      "General Hospital, A' pura-392",
      "Ginigathhena-471",
      "Girandurukotte-669",
      "Giriulla-553",
      "Godakawela-786",
      "Gonagaldeniya-316",
      "Gonagolla-438",
      "Gonapola-643",
      "Gothatuwa-721",
      "Grandpass-628",
      "Habarana-393",
      "Hakmana-691",
      "Haldummulla-463",
      "Hali ela-785",
      "Hambantota-085",
      "Hanwella-741",
      "Haputale-035",
      "Hasalaka-365",
      "Hatharaliyadda-472",
      "Hatton-040",
      "Head Office-999",
      "Hemmathagama-772",
      "Hettipola-570",
      "Hikkaduwa-609",
      "Hingurakgoda-601",
      "Hingurana-509",
      "Hiripitiya-569",
      "Homagama-568",
      "Horana-054",
      "Horowpathana-217",
      "Hyde Park-521",
      "Ibbagamuwa-770",
      "Illavalai-377",
      "Imaduwa-135",
      "Independent Square-453",
      "Ingiriya-604",
      "International Division-087",
      "Ipalogama-236",
      "Irakkamam-439",
      "Islamic Banking Unit-776",
      "Ja Ela-039",
      "Jaffna-005",
      "Jaffna 2nd Branch-500",
      "Jaffna Bus Stand-366",
      "Jaffna Main Street-368",
      "Jaffna University-369",
      "Jayanthipura-600",
      "Kadawatha-059",
      "Kadawatha 2nd City-780",
      "Kaduruwela-502",
      "Kaduwela-608",
      "Kahatagasdigiliya-622",
      "Kahawatte-507",
      "Kaithady-370",
      "Kalawana-645",
      "Kallady-426",
      "Kallar-427",
      "Kalmunai-510",
      "Kalpitiya-589",
      "Kalutara S/G-016",
      "Kaluwanchikudy-611",
      "Kalviyankadu-371",
      "Kamburupitiya-529",
      "Kandana-771",
      "Kandapola-633",
      "Kandy-002",
      "Kandy 2nd-649",
      "Kandy City Centre-473",
      "Kandy Hospital-454",
      "Kankesanthurai-605",
      "Kantale Bazaar-623",
      "Karadiyanaru-428",
      "Karainagar-749",
      "Karaitivu-429",
      "Karanavai-372",
      "Karapitiya-280",
      "Karawanella-294",
      "Karawita-295",
      "Katana-722",
      "Kataragama-616",
      "Kattankudy-648",
      "Katubedda-030",
      "Katugastota-666",
      "Katukurunda-625",
      "Katunayake I.P.Z.-658",
      "Katuneriya-332",
      "Katupotha-333",
      "Katuwana-261",
      "Katuwellegama Courtaulds Clothing Lanka (Pvt) Ltd-714",
      "Kayts-373",
      "Kebithigollawa-621",
      "Kegalle-027",
      "Kegalle Bazaar-536",
      "Kegalle Hospital-297",
      "Kekanadura-262",
      "Kekirawa-676",
      "Keppetipola-703",
      "Kesbewa-620",
      "Keselwatte-617",
      "Kilinochchi-093",
      "Kinniya-735",
      "Kiran-430",
      "Kiribathgoda-543",
      "Kiriella-317",
      "Kirimetiyana-334",
      "Kirindiwela-571",
      "Kirulapana-602",
      "Kitulgala-282",
      "Kobeigane-172",
      "Kochchikade-323",
      "Kodikamam-375",
      "Koggala E.P.Z-750",
      "Kokkadicholai-431",
      "Kokuvil-376",
      "Kollupitiya-034",
      "Kollupitiya 2nd-670",
      "Kolonna-283",
      "Kolonnawa-595",
      "Kopay-787",
      "Koslanda-629",
      "Kosmodera-263",
      "Kotagala-455",
      "Kotahena-663",
      "Kothalawala Defence University-813",
      "Kotiyakumbura-284",
      "Kottawa-773",
      "Kudawella-264",
      "Kuliyapitiya-052",
      "Kumbukgete-324",
      "Kurunduwatte-809",
      "Kurunegala-009",
      "Kurunegala Bazaar-513",
      "Kuruwita-325",
      "Lake House-636",
      "Lake View-612",
      "Lanka Hospital-603",
      "Lunugala-577",
      "Lunugamvehera-265",
      "Lunuwatte-647",
      "Madampe-544",
      "Madatugama-654",
      "Madawakkulama-805",
      "Madawala-581",
      "Madhu-378",
      "Madurankuliya-565",
      "Maha-Edanda-266",
      "Mahaoya-806",
      "Maharagama-055",
      "Mahawewa-319",
      "Mahiyangana-542",
      "Maho-564",
      "Main Street-026",
      "Makandura-299",
      "Makandura - Matara-267",
      "Makola-789",
      "Malabe-763",
      "Malimbada-268",
      "Malkaduwawa-255",
      "Mallavi-349",
      "Malwatte-422",
      "Mamangama-423",
      "Manipay-281",
      "Mankulam-574",
      "Mannar-046",
      "Manthikai-351",
      "Maradana-041",
      "Marassana-456",
      "Marawila-300",
      "Maruthamunai-424",
      "Maruthankerny-352",
      "Maskeliya-506",
      "Matale-068",
      "Matara-024",
      "Matara City-614",
      "Mattala Airport-796",
      "Mattegoda-583",
      "Matugama-556",
      "Mawanella-559",
      "Mawathagama-257",
      "Medagama-238",
      "Medawachchiya-162",
      "Medawala-797",
      "Medirigiriya-641",
      "Meegahakiwula-384",
      "Meegalewa-728",
      "Meepilimana-458",
      "Melsiripura-555",
      "Menikhinna-459",
      "Metropolitan-618",
      "Middeniya-518",
      "Mihintale-335",
      "Milagiriya-593",
      "Minneriya-394",
      "Minuwangoda-545",
      "Mirigama-088",
      "Mollipothana-417",
      "Monaragala-082",
      "Moneragala Town-705",
      "Moratumulla-557",
      "Moratuwa-061",
      "Morawaka-270",
      "Morawewa-418",
      "Morontota-285",
      "Mount Lavinia-766",
      "Mulankavil-353",
      "Mullativu-355",
      "Mulleriyawa New Town-723",
      "Mulliyawalai-511",
      "Murungan-356",
      "Muttur-118",
      "Nagoda-818",
      "Nainativu-357",
      "Naiwala-724",
      "Nallur-358",
      "Nanatan-359",
      "Narahenpita-762",
      "Narammala-534",
      "National Institute Of Education-552",
      "Nattandiya-050",
      "Naula-092",
      "Navithanvely-419",
      "Nawalapitiya-598",
      "Nedunkerny-360",
      "Negombo-018",
      "Negombo Bazzar-572",
      "Nelliady-638",
      "Nelundeniya-799",
      "Neluwa-667",
      "Nikaweratiya-547",
      "Nilavely-420",
      "Nintavur-591",
      "Nittambuwa-675",
      "Nivitigala-597",
      "Nochchiyagama-656",
      "Norchcholei-779",
      "Nugegoda Supergrade-049",
      "Nuwara Eliya-029",
      "Oddamavady-402",
      "Oddusudan-361",
      "Okkampitiya-706",
      "Oluwil-403",
      "Omanthai-362",
      "Padavi Parakramapura-127",
      "Padaviya-395",
      "Padiyapelella-492",
      "Padiyatalawa-348",
      "Padukka-678",
      "Palapathwela-461",
      "Palaviya-301",
      "Pallai-363",
      "Pallama-302",
      "Pallebedda-816",
      "Pallekelle-464",
      "Pallepola-640",
      "Palmuddai-406",
      "Palugamam-404",
      "Panadura-007",
      "Panadura Bazaar-607",
      "Pannala-546",
      "Paragahadeniya-303",
      "Paranthan-364",
      "Parliamentary Complex-644",
      "Pasgoda-271",
      "Passara-503",
      "Pelawatta-690",
      "Pelawatta-707",
      "Pelawatte City Kalutara-541",
      "Peliyagoda-042",
      "Pelmadulla-683",
      "Pemaduwa-152",
      "Peradeniya-588",
      "Personal-681",
      "Pesalai-344",
      "Pettah-004",
      "Pilimatalawa-587",
      "Piliyandala-736",
      "Pinnawala-287",
      "Pitabeddara-272",
      "Pitakotte-533",
      "Pitigala-610",
      "Point Pedro-028",
      "Polgahawela-526",
      "Polonnaruwa New Town-083",
      "Polpithigama-783",
      "Polwatte-405",
      "Poonagary-345",
      "Poovarasankulam-346",
      "Pothuhera-664",
      "Potuvil-318",
      "Primary Dealer Unit-099",
      "Provincial Council Complex, Pallakelle-802",
      "Pugoda-765",
      "Pujapitiya-441",
      "Pundaluoya-425",
      "Punnalaikadduvan-347",
      "Pussellawa-337",
      "Puthukudieruppu-341",
      "Puthukulam-342",
      "Puttalam-048",
      "Raddolugama-687",
      "Ragala-442",
      "Ragama-764",
      "Rajagiriya-746",
      "Rajanganaya-396",
      "Rajina Junction-397",
      "Rakwana-594",
      "Rambewa-782",
      "Rambukkana-582",
      "Ranajayapura-398",
      "Ranna-767",
      "Rathgama-259",
      "Ratmalana-689",
      "Ratnapura-031",
      "Ratnapura Bazaar-684",
      "Ratnapura Hospital-315",
      "Rattota-639",
      "Regent Street-627",
      "Ridigama-532",
      "Rikillagaskada-167",
      "Ruhunu Campus-693",
      "Ruwanwella-585",
      "Sabaragamuwa Provincial Council-288",
      "Sabaragamuwa University-286",
      "Sainthamarathu-407",
      "Saliyawewa-814",
      "Samanthurai-440",
      "Savalkaddu-338",
      "Seeduwa-421",
      "Seethawakapura-290",
      "Serunuwara-408",
      "Sevanapitiya-399",
      "Sewagama-183",
      "Sigiriya-443",
      "Sirupiddy-339",
      "Siyambalanduwa-416",
      "Sri Jayawardenapura Hospital-520",
      "Suriyawewa-751",
      "Talatuoya-650",
      "Talawakelle-531",
      "Talgaswela-596",
      "Tambuttegama-655",
      "Tangalle-056",
      "Taprobane-747",
      "Tawalama-250",
      "Teldeniya-781",
      "Thalaimannar Pier-336",
      "Thalawa-400",
      "Thalawathugoda-516",
      "Thalduwa-798",
      "Thambiluvil-409",
      "Thampalakamam-410",
      "Thanamalwila-322",
      "Thanthirimale-256",
      "Thihagoda-752",
      "Thimbirigasyaya-512",
      "Thirumurukandi-326",
      "Thirunelvely-761",
      "Thoduwawa-305",
      "Thoppur-411",
      "Tirappane-157",
      "Tissamaharama-538",
      "Treasury Division-760",
      "Trincomalee-006",
      "Trincomalee Bazaar-624",
      "Uda Dumbara-606",
      "Udappuwa-306",
      "Udawalawe-291",
      "Udugama-753",
      "Uhana-413",
      "Ukuwela-444",
      "Union Place-043",
      "University Of Peradeniya-445",
      "Upcott-446",
      "Uppuvely-414",
      "Uragasmanhandiya-748",
      "Urubokka-298",
      "Urumpirai-794",
      "Uva Paranagama-343",
      "Vaddukoddai-804",
      "Vakarai-415",
      "Valachchenai-626",
      "Valvettithurai-791",
      "Vavunathivu-385",
      "Vavuniya-044",
      "Vavuniya City-793",
      "Velanai-063",
      "Vellaveli-386",
      "Veyangoda-682",
      "Visakha-775",
      "Visuvamadu-328",
      "Wadduwa-584",
      "Wahalkada-815",
      "Waikkal-558",
      "Walapane-743",
      "Walasmulla-517",
      "Walgama-744",
      "Wanduramba-800",
      "Warakapola-562",
      "Warapitiya-733",
      "Ward Place-685",
      "Wariyapola-379",
      "Wattala-505",
      "Wattegama-340",
      "Wayamba University-307",
      "Weeraketiya-139",
      "Weerapokuna-308",
      "Weligama-550",
      "Weligepola-292",
      "Welikanda-817",
      "Welimada-730",
      "Weli-Oya-274",
      "Welioya-Sampath Nuwara-803",
      "Welisara-527",
      "Weliweriya-677",
      "Wellawa-309",
      "Wellawatte-023",
      "Wellawaya-434",
      "Welpalla-104",
      "Wennappuwa-508",
      "Wijerama Junction-499",
      "Wilgamuwa-447",
      "Yakkala-769",
      "Yakkalamulla-578",
      "Yatawatte-144",
      "Yatiyantota-477",
    ],
    "7481-Cargills Bank Limited": [
      "Central Processing Office-925",
      "Chunnakkam-011",
      "Corporate-001",
      "Galle-012",
      "Hawaeliya-007",
      "Jaffna City Center-010",
      "Kandy-014",
      "Kurunegala-009",
      "Maharagama-005",
      "Maitland Crescent-002",
      "Maitland Crescent-002",
      "Matara-004",
      "Nuwara Eliya-013",
      "Old Moor Street-003",
      "Old Moor Street-003",
      "Peradeniya-015",
      "Thanamalwila-008",
      "Vavuniya-006",
    ],
    "8004-Central Bank of Sri Lanka": [
      "CBSL-VB-998",
      "Central Bank Of Sri Lanka-999",
      "Head Office-001",
    ],
    "7825-Central Finance PLC": ["Colombo-001", "Kandy-002", "Nugegoda-016"],
    "7047-Citi Bank": [
      "Cash Mgmt-100",
      "Head Office-000",
      "Head Office-001",
      "Head Office-999",
    ],
    "7746-Citizen Development Business Finance PLC": [
      "Aluthgama-069",
      "Ambalangoda-057",
      "Anuradhapura-011",
      "Avissawella-065",
      "Badulla-009",
      "Bandarawela-036",
      "Battaramulla-024",
      "Batticaloa-034",
      "Boralesgamuwa-043",
      "Chilaw-010",
      "Colombo Office-031",
      "Dambulla-028",
      "Dehiwala-060",
      "Eheliyagoda-042",
      "Ela Kanda-041",
      "Embilipitiya-023",
      "Galle-027",
      "Gampaha-007",
      "Giriulla-072",
      "Head Office-038",
      "Horana-050",
      "Ja-Ela-014",
      "Jaffna-032",
      "Kadana-039",
      "Kaduruwela-029",
      "Kaduwela-015",
      "Kaluthara-020",
      "Kandy-006",
      "Katugasthota-054",
      "Kegalle-016",
      "Kelaniya-005",
      "Kochchikade-052",
      "Kotahena-030",
      "Kottawa-062",
      "Kuliyapitiya-045",
      "Kurunegala-004",
      "Kuruvita-068",
      "Mahara-026",
      "Maharagama-021",
      "Mahiyanganaya-070",
      "Malabe-058",
      "Marawila-044",
      "Matale-055",
      "Matara-022",
      "Mathugama-019",
      "Mawathagama-064",
      "Minuwangoda-059",
      "Moratuwa-002",
      "Narammala-063",
      "Negombo-003",
      "Nikaweratiya-067",
      "Nittambuwa-017",
      "Nugegoda-048",
      "Panadura-047",
      "Pelmadulla-051",
      "Piliyandala-056",
      "Premier Center-049",
      "Ragama-040",
      "Rajagiriya-053",
      "Rathnapura-008",
      "Ratmalana-046",
      "Thalawathugoda-071",
      "Tissamaharama-025",
      "Trincomalee-035",
      "Vavuniya-033",
      "Warakapola-061",
      "Wariyapola-066",
      "Wattala-013",
      "Wellawatta-012",
      "Wennappuwa-018",
    ],
    "7056-Commercial Bank PLC": [
      "Akkaraipattu-172",
      "Akurana Service Point -219",
      "Akuressa-035",
      "Alawwa-188",
      "Aluthgama-040",
      "Ambalangoda-097",
      "Ambalantota-063",
      "Ampara-100",
      "Anniwatte CSP-254",
      "Anuradhapura-053",
      "Anuradhapura New Town-185",
      "Atchchuvely-156",
      "Athurugiriya-130",
      "Attidiya-231",
      "Avissawella-070",
      "Baddegama-098",
      "Badulla-052",
      "Badulla Minicom-244",
      "Balangoda-082",
      "Bambalapitiya-106",
      "Bandaragama (C.S.P.)-084",
      "Bandarawatta (Laugfs Super)-247",
      "Bandarawela-080",
      "Baseline -113",
      "Batapola-240",
      "Batharamulla Arpico Super Centre-252",
      "Battaramulla-029",
      "Batticaloa-105",
      "Batticaloa Minicom-242",
      "Beliatta-181",
      "Beruwala CSP-220",
      "BIA Counter-249",
      "Biyagama-147",
      "Bokundara CSP-226",
      "Boralesgamuwa-142",
      "Boralesgamuwa CSP-132",
      "Borella-019",
      "Card Centre -095",
      "Chankanai-239",
      "Chavakachcheri-126",
      "Chenkalady-168",
      "Chilaw-043",
      "Chunakkam-107",
      "City Office-002",
      "Colombo 07-050",
      "Colombo Gold Centre-237",
      "Dambulla-054",
      "Dankotuwa-164",
      "Dehiwala-058",
      "Dehiwala Arpico Super Centre-251",
      "Deiyandara-276",
      "Delgoda Laugfs Super-269",
      "Delkanda -134",
      "Deniyaya-111",
      "Digana-140",
      "Divulapitiya-180",
      "Duplication Road-068",
      "Eheliyagoda-158",
      "Ekala  (CSP)-071",
      "Elpitiya-103",
      "Embilipitiya-030",
      "Foreign-003",
      "Galewela-009",
      "Galle City-027",
      "Galle City Minicom-271",
      "Galle Fort-005",
      "Gampaha-044",
      "Gampaha CSP-218",
      "Gampola-102",
      "Ganemulla-177",
      "Gelioya Service Point-265",
      "Giriulla-182",
      "Godakawela CSP-197",
      "Grandpass-057",
      "Hambantota-166",
      "Hanwella-143",
      "Hatton-115",
      "Head Office-000",
      "Head Office-001",
      "Head Office-999",
      "Hendala Service Point-264",
      "Hikkaduwa-014",
      "Hingurakgoda-015",
      "Holiday Banking Centre - Majestic City-258",
      "Homagama-075",
      "Horana-076",
      "Horana Service Point-224",
      "Hulftsdorp-232",
      "Hydepark Arpico Service Center-253",
      "Islamic Banking Unit-901",
      "Ja - Ela (K-Zone)-230",
      "Ja-Ela-081",
      "Jaffna-006",
      "Kadawatha-067",
      "Kadawatha (Arpico Super)-234",
      "Kaduruwela-088",
      "Kaduwela-042",
      "Kahawatta-133",
      "Kalawana-138",
      "Kalmunai-152",
      "Kalutara-036",
      "Kalutara (Arpico Super)-267",
      "Kamburupitiya-104",
      "Kandana-031",
      "Kandy-004",
      "Kandy City office-150",
      "karapitiya-135",
      "Kataragama-173",
      "Kattankudy-193",
      "Katubedda-114",
      "Katubedda CSP-167",
      "Katugastota-045",
      "Katugastota (Minicom)-245",
      "Katukurunda CSP-227",
      "Katunayake 24/7 Centre-190",
      "Katunayake FTZ-025",
      "Kegalle-021",
      "Kekirawa-110",
      "Keyzer Street-039",
      "Kilinochchi-155",
      "Kilinochchi Minicom-272",
      "Kiribathgoda-069",
      "Kiribathgoda Service Point-257",
      "Kirindiwela-139",
      "Kirulapona-047",
      "Kirulapone Minicom-217",
      "Kochchikade -074",
      "Kodikamam-198",
      "Koggala-028",
      "Kohuwala-087",
      "Kohuwala Service Point-266",
      "Kollupitiya-011",
      "Kotahena-012",
      "Kotikawatta-119",
      "Kottawa-121",
      "Kuliyapitiya-051",
      "Kundasale (Dumbara Super CSP)-255",
      "Kurunegala-016",
      "Kurunegala City Office-122",
      "Kurunegala Service Point-212",
      "Kuruwita-175",
      "Liberty Plaza CSP-196",
      "Maharagama-018",
      "Maharagama Minicom-209",
      "Mahiyanganaya-137",
      "Makola -199",
      "Malabe (C.S.P.)-086",
      "Manipay-153",
      "Mannar-154",
      "Maradana-032",
      "Marawila -183",
      "Maskeliya-195",
      "Matale-008",
      "Matara-007",
      "Matara City office-151",
      "Matara Minicom Centre-222",
      "Mathugama-096",
      "Mattegoda (Laugfs Super)-268",
      "Mawanella-079",
      "Mawathagama-161",
      "Medawachchiya-200",
      "Middeniya-176",
      "Minuwangoda-033",
      "Mirigama-066",
      "Monaragala-120",
      "Moratuwa-059",
      "Moratuwa Minicom-210",
      "Morawaka-277",
      "Mount Lavinia(C.S.P.)-093",
      "Mulliyawalai-229",
      "Mutuwal-023",
      "Narahenpita-022",
      "Narammala-060",
      "Nattandiya-055",
      "Nawala  (C.S.P.)-101",
      "Nawala Service Point-208",
      "Nawalapitiya-089",
      "Nawam Mawatha -259",
      "Nawinna (Arpico Super)-238",
      "Negambo Arpico Super Centre-256",
      "Negombo-013",
      "Negombo Extension Office-118",
      "Nelliady-108",
      "Neluwa-125",
      "Nikaweratiya-083",
      "Nittambuwa-065",
      "Nittambuwa CSP-261",
      "Nochchiyagama-241",
      "Nugegoda-020",
      "Nuwara Eliya-034",
      "Old Moor Street-017",
      "Orion City ABC-270",
      "Padukka -187",
      "Palavi -206",
      "Panadura-041",
      "Panadura CSP-223",
      "Panadura Second-189",
      "Panchikawatte-038",
      "Pannala-144",
      "Passara-186",
      "Pelawatte CSP-262",
      "Peliyagoda CSP-165",
      "Pelmadulla-149",
      "Peradeniya  (CSP)-073",
      "Pettah-024",
      "Pettah Main Street-072",
      "Pilimathalawa-109",
      "Piliyandala-077",
      "Pitakotte CSP-117",
      "Polgahawela-141",
      "Pottuvil-194",
      "Priority Banking Centre-169",
      "Puttlam-148",
      "Raddolugama -131",
      "Ragama -221",
      "Rajagiriya-062",
      "Rajagiriya (Keells Super)-233",
      "Ramanayake Mawatha-216",
      "Ratmalana-046",
      "Ratnapura-049",
      "Ratnapura (Laugfs Super)-213",
      "Reid Avenue-116",
      "Ruwanwella-163",
      "Seeduwa-064",
      "SLIC- CSP-204",
      "Stanley Road, Jaffna -127",
      "Tangalle-123",
      "Thalawakelle-184",
      "Thalawathugoda (C.S.P.)-078",
      "Thambuttegama-162",
      "Thirunelvely-157",
      "Tissamaharama-124",
      "Trincomalee-037",
      "Udugama-129",
      "Union Place-048",
      "Union Place (Keells Super) Branch-211",
      "Urubokka-236",
      "Valachchenai-159",
      "Vavuniya-061",
      "Vavuniya Extension Office-171",
      "Velanai-170",
      "Veyangoda-250",
      "Wadduwa-146",
      "Warakapola-128",
      "Ward Place-145",
      "Wariyapola-174",
      "Wattala-056",
      "Wattala Arpico Super Center-260",
      "Wattala Minicom-225",
      "Wattgama-246",
      "Weligama-112",
      "Welimada-136",
      "Weliweria -228",
      "Wellawatte-010",
      "Wellawatte 2nd-179",
      "Wellawaya-160",
      "Wennappuwa-026",
      "Wennapuwa (Arpico) Super-248",
      "World Trade Centre-178",
      "Yakkala-085",
    ],
    "7870-Commercial Credit & Finance PLC": [
      "Akkaraipattu-114",
      "Akurana-138",
      "Akuressa-098",
      "Aluthgama-081",
      "Ambalangoda-001",
      "Ambalantota-005",
      "Ampara-077",
      "Anamaduwa-127",
      "Angunakolapelessa-120",
      "Anuradhapura-076",
      "Aralaganwila-073",
      "Avissawella-074",
      "Baddegama-124",
      "Badulla-008",
      "Bakamuna-097",
      "Balangoda-022",
      "Bandaragama-051",
      "Bandarawela-003",
      "Battaramulla-111",
      "Batticaloa-002",
      "Beruwala-132",
      "Bibile-108",
      "Chavakachcheri-113",
      "Chilaw-119",
      "Chunnakam-090",
      "City Office-A-064",
      "City Office-B-014",
      "City Office-C-058",
      "City Office-Colombo-049",
      "City Office-D-068",
      "City Office-E-009",
      "City Office-F-056",
      "City Office-G-055",
      "City Office-H-066",
      "City Office-I-004",
      "City Office-J-071",
      "City Office-K-057",
      "City Office-M-034",
      "City Office-None Fd-050",
      "City Office-P-047",
      "City Office-Q-059",
      "City Office-S-037",
      "Dambulla-063",
      "Dehiattakandiya-060",
      "Delft-089",
      "Deniyaya-062",
      "Deraniyagala-118",
      "Divulapitiya-131",
      "Elpitiya-061",
      "Embilipitiya-013",
      "Galagedara-137",
      "Galenbindunuwewa-067",
      "Galgamuwa-136",
      "Galle-065",
      "Galnewa-039",
      "Gampaha-041",
      "Gampola-093",
      "Giriulla-105",
      "Godakawela-130",
      "Hatton-104",
      "Hingurakgoda-017",
      "Homagama-032",
      "Horana-079",
      "Horowpathana-083",
      "Ingiriya-123",
      "Ja-Ela-133",
      "Jaffna-078",
      "Kaduwela-016",
      "Kalawana-129",
      "Kalmunai-012",
      "Kalpitiya-046",
      "Kalutara-010",
      "Kaluwanchikudy-135",
      "Kandy-070",
      "Kanthale-007",
      "Kcc -072",
      "Kegalle-069",
      "Kekirawa-087",
      "Kilinochchi-053",
      "Kinniya-128",
      "Kiribathgoda-139",
      "Kirindiwela-102",
      "Kuliyapitiya-052",
      "Kurunegala-006",
      "Mahaoya-110",
      "Maharagama-048",
      "Mahiyanganaya-043",
      "Mannar-045",
      "Matale-018",
      "Matara-044",
      "Mathugama-031",
      "Medawachchiya-029",
      "Melsiripura-096",
      "Monaragala-054",
      "Moratuwa-030",
      "Mount Lavinia-099",
      "Mullativu-117",
      "Muthur-101",
      "Naththandiya-126",
      "Nawalapitiya-038",
      "Negombo-035",
      "Nelliady-019",
      "Neluwa-084",
      "Nikaweratiya-036",
      "Nittambuwa-025",
      "Nochchiyagama-082",
      "Nugegoda-033",
      "Nuwara Eliya-023",
      "Padaviya-021",
      "Panadura-091",
      "Pilimathalawa -121",
      "Piliyandala-134",
      "Polonnaruwa-026",
      "Polpithigama-112",
      "Pothuvil-107",
      "Pulmude-086",
      "Pussellawa-116",
      "Puttalam-028",
      "Ratnapura-027",
      "Rikillagaskada-040",
      "Siyambalanduwa-085",
      "Tangalle-125",
      "Teldeniya-103",
      "Thambuththegama-042",
      "Thanamalwila-106",
      "Tissamaharama-122",
      "Trincomalee-020",
      "Udugama-095",
      "Valaichchenai-115",
      "Vavuniya-024",
      "Warakapola-109",
      "Wariyapola-094",
      "Wattala-011",
      "Weligama-092",
      "Welikanda-100",
      "Welimada-080",
      "Wellawatte-075",
      "Wellawaya-140",
      "Wennappuwa-015",
    ],
    "7807-Commercial Leasing & Finance": [
      "Head Office-001",
      "Virtual Branch-002",
    ],
    "7205-Deutsche Bank": [
      "Head Office-000",
      "Head Office-999",
      "Main Branch-001",
    ],
    "7454-DFCC Vardhana Bank Ltd": [
      "Akkaraipattu-058",
      "Akuressa-054",
      "Ambalangoda-038",
      "Ambalantota-095",
      "Ampara-041",
      "Anuradhapura-009",
      "Aralaganwila-085",
      "Avissawella-039",
      "Badulla-011",
      "Balangoda-080",
      "Bandaragama-081",
      "Bandaranayake Mawatha-015",
      "Bandarawela-017",
      "Batticaloa-040",
      "Borella-012",
      "Central Operations-800",
      "Central Province SLP Units-531",
      "Chilaw-032",
      "Chunnakam-059",
      "City Office-007",
      "Dambulla-020",
      "Dankotuwa-094",
      "Dehiattakandiya-084",
      "Deniyaya-025",
      "Digana-065",
      "Eastern  Province SLP Units-561",
      "Eheliyagoda-068",
      "Elpitiya-053",
      "Embilipitiya-045",
      "Galewela-067",
      "Galle-035",
      "Gampaha-010",
      "Gampola-030",
      "Gangodawila-076",
      "Giriulla-090",
      "Hambantota-062",
      "Hatton-073",
      "Head Office-001",
      "Head Office-999",
      "Hikkaduwa-092",
      "Hingurakgoda-079",
      "Horana-034",
      "Ibbagamuwa-075",
      "Ja Ela-063",
      "Jaffna-042",
      "Kadawatha-029",
      "Kaduruwela-014",
      "Kaduwela-078",
      "Kahawatta-088",
      "Kalawana-037",
      "Kaluthara-026",
      "Kandy City Centre-083",
      "Kattankudy-055",
      "Katugastota-006",
      "Katugastota-048",
      "Kegalle-049",
      "Kilinochchi-052",
      "Kiribathgoda-027",
      "Kochchikade-089",
      "Kotahena-064",
      "Kottawa-019",
      "Kuliyapitiya-022",
      "Kurunegala-005",
      "Maharagama-016",
      "Malabe-003",
      "Manipai-060",
      "Matale-031",
      "Matara-004",
      "Mathugama-069",
      "Medirigiriya-086",
      "Monaragala-050",
      "Moratuwa-043",
      "Mount Lavinia-072",
      "Narammala-070",
      "Nawala-028",
      "Nawalapitiya-093",
      "Negombo-018",
      "Nelliady-061",
      "Nikaweratiya-071",
      "North Central  Province SLP Units-551",
      "North Western Province SLP Units-521",
      "Nugegoda-002",
      "Nuwara Eliya-036",
      "Oddamavadi-057",
      "Panadura-023",
      "Peradeniya-082",
      "Pettah Peoples Park-046",
      "Pettah-Main Street-087",
      "Piliyandala-024",
      "Premier Banking Centre-700",
      "Rathnapura-008",
      "Sabaragamuwa Province SLP Units-541",
      "Sainthamaruthu-051",
      "Southern Province SLP Units-501",
      "Tangalle-056",
      "Thambuttegama-066",
      "Trincomalee-044",
      "Uva Province SLP Units-571",
      "Vavuniya-047",
      "Wattala-021",
      "Wattegama-096",
      "Weligama-077",
      "Welimada-074",
      "Wellawatte-033",
      "Wennappuwa-091",
      "Western  Province SLP Units-511",
    ],
    "7074-Habib Bank Ltd": [
      " Dharmapala Mawatha-002",
      "Galle-006",
      "Habib Bank Ltd-000",
      "Head Office-999",
      "Islamic Banking-021",
      "Kalmunai-003",
      "Kandy-005",
      "Pettah -001",
      "Wellawatte-007",
    ],
    "7083-Hatton National Bank PLC": [
      "Akkaraipattu-078",
      "Akurana-236",
      "Akuressa-151",
      "Alawwa-123",
      "Aluthgama-109",
      "Aluthkade-001",
      "Ambalangoda-081",
      "Ambalantota-045",
      "Ampara-058",
      "Anamaduwa-177",
      "Angunakolapelassa-239",
      "Anuradhapura-010",
      "Anuradhapura Metro-232",
      "Aralaganwila-193",
      "Asiri Surgical Hospital-249",
      "Atchchuvely-189",
      "Athurugiriya-154",
      "Avissawella-111",
      "Badulla-011",
      "Balangoda-071",
      "Bambalapitiya-039",
      "Bandaragama-201",
      "Bandarawela-012",
      "Batapola-215",
      "Batticaloa-057",
      "Beruwela-160",
      "Bibile-233",
      "Biyagama-047",
      "Bogawanthalawa-060",
      "Boralesgamuwa-112",
      "Borella-055",
      "Buttala-075",
      "Card Centre-113",
      "Central Colombo-114",
      "Chankanai-157",
      "Chavakachcheri-137",
      "Chilaw-040",
      "Chunnakam-117",
      "Cinnamon Gardens-076",
      "City Office-002",
      "Dambulla-048",
      "Dankotuwa-070",
      "Dehiattakandiya-196",
      "Dehiwala-093",
      "Delgoda-122",
      "Dematagoda-103",
      "Deniyaya Customer Centre-120",
      "Devinuwara-238",
      "Digana-176",
      "Digital Branch-500",
      "Dikwella-178",
      "Divulapitiya-229",
      "Ekala-230",
      "Elpitiya-107",
      "Embilipitiya-050",
      "Eravur-135",
      "Galaha-198",
      "Galewela-149",
      "Galgamuwa-128",
      "Galle-013",
      "Gampaha-051",
      "Gampola-014",
      "Ganemulla-136",
      "Gelioya-218",
      "Ginigathhena-173",
      "Giriulla-148",
      "Godakawela-235",
      "Grandpass-046",
      "Green Path-005",
      "Hakmana-200",
      "Hambantota-068",
      "Hanwella-139",
      "Haputale-234",
      "Hatton-015",
      "Head Office-003",
      "Head Office-004",
      "Hendala-131",
      "Hettipola-152",
      "Hikkaduwa-202",
      "Homagama-077",
      "Horana-052",
      "Hulftsdorp-063",
      "Ingiriya-245",
      "International Division-054",
      "Islamic Banking Unit-250",
      "Ja-Ela-087",
      "Jaffna-219",
      "Jaffna Metro-016",
      "Jampettah Street-207",
      "Kadawatha-084",
      "Kaduwela-082",
      "Kahawatte-017",
      "Kaithady-241",
      "Kalawana-197",
      "Kallady-192",
      "Kalmunai-091",
      "Kalutara-034",
      "Kaluwanchikudy-165",
      "Kandana-119",
      "Kandy-018",
      "Kantale-095",
      "Karaitive-184",
      "Karapitiya-227",
      "Kataragama-240",
      "Kattankudy-211",
      "Katugastota-100",
      "Katunayake-049",
      "Kegalle-041",
      "Kekirawa-231",
      "Kelaniya-138",
      "Kilinochchi South-146",
      "Killinochchi North-195",
      "Kinniya-169",
      "Kiribathgoda-056",
      "Kirindiwela-099",
      "Kirulapone-043",
      "Kochchikade-155",
      "Kodikamam-190",
      "Koggala-237",
      "Kohuwela-129",
      "Kollupitiya-115",
      "Kolonnawa-194",
      "Kotahena-096",
      "Kottawa-098",
      "Kuliyapitiya-074",
      "Kundasale-188",
      "Kurumankadu-206",
      "Kurunduwatte-243",
      "Kurunegala-019",
      "Kurunegala Metro-224",
      "Lanka Hospital-251",
      "Lotus Road-248",
      "Madampe-168",
      "Maharagama-064",
      "Mahiyanganaya-124",
      "Malabe-156",
      "Maligawatta-006",
      "Mallavi-212",
      "Manipay-150",
      "Mannar-020",
      "Maradana-108",
      "Marandagahamula-079",
      "Marawila-080",
      "Maruthamunai-185",
      "Maskeliya-021",
      "Matale-065",
      "Matara-042",
      "Mathugama-125",
      "Mawanella-089",
      "Medawachchiya-143",
      "Medirigiriya-179",
      "Middeniya-127",
      "Minuwangoda-094",
      "Mirigama-180",
      "Mirihana-204",
      "Monaragala-053",
      "Moratumulla-073",
      "Moratuwa-022",
      "Mount Lavinia-061",
      "Mullativu-183",
      "Mullipothanai-174",
      "Mulliyawalai-205",
      "Muthur-191",
      "Mutwal-097",
      "Nanattan-172",
      "Narahenpita-104",
      "Nawala-147",
      "Nawalapitiya-023",
      "Nawam Mawatha-701",
      "Negombo-024",
      "Negombo Metro-145",
      "Nelliady-118",
      "Nikaweratiya-121",
      "Ninthavur-159",
      "Nittambuwa-025",
      "Nochchiyagama-026",
      "Norochchole-133",
      "Nugegoda-027",
      "Nuwara Eliya-028",
      "Padavi Parakramapura-181",
      "Padukka-140",
      "Pamankada-221",
      "Pamunugama-210",
      "Panadura-069",
      "Panchikawatta-059",
      "Passara-220",
      "Peliyagoda-228",
      "Pelmadulla-101",
      "Peradeniya-223",
      "Pettah-007",
      "Pettah Metro-247",
      "Pilimatalawa-141",
      "Piliyandala-038",
      "Pinnawala-066",
      "Pitigala-187",
      "Point Pedro-132",
      "Polonnaruwa-044",
      "Pottuvil-158",
      "Pugoda-166",
      "Pussellawa-029",
      "Puttalam-083",
      "Ragala-244",
      "Ragama-102",
      "Rajagiriya-036",
      "Ratmalana-208",
      "Ratnapura-030",
      "Rikillagaskada-162",
      "Sammanthurai-222",
      "Sea Street-072",
      "Seeduwa-209",
      "Serunuwara-186",
      "Siyabalanduwa-170",
      "Suriyawewa-067",
      "Talangama-085",
      "Tangalle-086",
      "Thalawakele-246",
      "Thalawathugoda-142",
      "Thambuttegama-088",
      "Thandenweli-164",
      "Thimbirigasyaya-092",
      "Thirukovil-134",
      "Thirunelvely-144",
      "Tissamaharama-090",
      "Treasury Division-105",
      "Trincomalee-031",
      "Trincomalee Metro-225",
      "Udappuwa-171",
      "Uhana-182",
      "Uppuvelli-175",
      "Urubokka-199",
      "Valachchenai-167",
      "Vavuniya-032",
      "Velanai-161",
      "Veyangoda-214",
      "Wadduwa-203",
      "Walasmulla-217",
      "Warakapola-126",
      "Wariyapola-153",
      "Wattala-035",
      "Weligama-213",
      "Welimada-033",
      "Weliweriya-130",
      "Wellawatta-009",
      "Wellawaya-106",
      "Wennappuwa-110",
      "Wijerama-226",
      "World Trade Centre-703",
      "Yakkala-163",
      "Yakkalamulla-216",
    ],
    "7737-HDFC Bank": ["Head Office-001"],
    "7092-Hongkong Shanghai Bank": [
      "Bambalapitiya-007",
      "Colpetty-003",
      "Galle-022",
      "Head Office-001",
      "Head Office-999",
      "Hongkong & Shanghai Bank-000",
      "Jaffna-021",
      "Kandy-002",
      "kohuwela-020",
      "Moratuwa-018",
      "Negombo-017",
      "Nugegoda-005",
      "Pelawatte-008",
      "Premier Centre-015",
      "Union Place-012",
      "Wattala-014",
      "Wellawatte-004",
      "World Trade Center-006",
    ],
    "7384-ICICI Bank Ltd": ["Sri Lanka Branch-001"],
    "7108-Indian Bank": [
      "Head Office-000",
      "Head Office-001",
      "Head Office-999",
      "Jaffna-002",
    ],
    "7117-Indian Overseas Bank": [
      "Head Office-000",
      "Head Office-999",
      "Matara-001",
    ],
    "7834-Kanrich Finance Limited": ["Head Office-001"],
    "7861-Lanka Orix Finance PLC": ["Head Office-000"],
    "7773-LB Finance PLC": [
      "Achchuveli-118",
      "Akkaraipattu-055",
      "Akuressa -087",
      "Aluthgama-069",
      "Ambalangoda-015",
      "Ampara-016",
      "Anamaduwa-110",
      "Anuradhapura-008",
      "Anuradhapura 02-059",
      "Avissawella-017",
      "Badulla -006",
      "Badulla City -082",
      "Balangoda-024",
      "Bandarawela-026",
      "Battaramulla-092",
      "Batticaloa-029",
      "Boralesgamuwa-022",
      "Chavakachcheri-046",
      "Chenkalady-096",
      "Chilaw-019",
      "Chunnakam-044",
      "Corporate Office -002",
      "Dam Street-086",
      "Dambulla-023",
      "Dehiattakandiya-105",
      "Dehiwala-027",
      "Delgoda-112",
      "Delkada-084",
      "Deniyaya-098",
      "Divulapitiya-115",
      "Eheliyagoda-113",
      "Elpitiya-030",
      "Embilipitiya-028",
      "Galle-009",
      "Gampaha-018",
      "Gampola-040",
      "Gelioya-107",
      "Hatton-050",
      "Head Office -001",
      "Homagama-075",
      "Horana-041",
      "Ja Ela-083",
      "Jaffna-043",
      "Jaffna City-099",
      "Jaffna Premier-100",
      "Kadawatha-042",
      "Kaduwela-073",
      "Kalawanchikudy-066",
      "Kalmunai-064",
      "Kalutara-014",
      "Kandana-032",
      "Kandy -005",
      "Kandy City -070",
      "Kaththankudi-085",
      "Katugasthota-063",
      "Kegalle-025",
      "Kekirawa-114",
      "Kilinochchi-047",
      "Kinniya-109",
      "Kiribathgoda-010",
      "Kochchikade-057",
      "Kokkadicholai-106",
      "Kotahena-058",
      "Kottawa-104",
      "Kotte-081",
      "Kuliyapitiya-037",
      "Kurunegala-011",
      "Kurunegala City -076",
      "Kurunegala Premier Centre-093",
      "Maharagama-036",
      "Mahiyanganaya-033",
      "Malabe-072",
      "Manipay -045",
      "Maradana-031",
      "Maskeliya-077",
      "Matale-035",
      "Matara-013",
      "Matara City -068",
      "Matugama-052",
      "Medawachchiya-095",
      "Medirigiriya-117",
      "Monaragala-088",
      "Moratumulla-065",
      "Moratuwa-094",
      "Mount Lavinia-090",
      "Narammala-116",
      "Nawalapitiya-074",
      "Negambo-004",
      "Nelliady -051",
      "Neluwa-091",
      "Nugegoda-003",
      "Nuwara Eliya-049",
      "Panadura-007",
      "Pilimathalawa-062",
      "Piliyandala-021",
      "Pitigala-078",
      "Polonnaruwa-020",
      "Pothuvil-056",
      "Pussellawa-097",
      "Puthukkudiyiruppu-111",
      "Puttalam-038",
      "Rajagiriya-060",
      "Ratnapura-012",
      "Saindamarthu -080",
      "Samanturei-079",
      "Sea Street-067",
      "Tangalle-089",
      "Thambuththegama-054",
      "Tissamaharama-034",
      "Trincomalee-039",
      "Valaichchenai-101",
      "Vavuniya-048",
      "Warakapola-071",
      "Wattala-102",
      "Welimada-061",
      "Wennappuwa-053",
    ],
    "7269-MCB Bank Ltd": [
      "Batticaloa-007",
      "Galle-008",
      "Head Office-001",
      "Head Office-999",
      "Islamic Banking Unit-004",
      "Kandy-006",
      "Kollupitiya-009",
      "Maradana-003",
      "Middle East Bank-000",
      "Pettah-002",
      "Wellawatte-005",
    ],
    "7913-Mercantile Investment and Finance PLC": ["Head Office-001"],
    "7898-Merchant Bank of Sri Lanka & Finance PLC": [
      "Ambalangoda-114",
      "Ambalantota-116",
      "Ampara-115",
      "Anuradhapura-112",
      "Avissawella-117",
      "Bandarawela-118",
      "Batticaloa-119",
      "Chilaw-120",
      "City Office-121",
      "Dambulla-122",
      "Deniyaya-123",
      "Embilipitiya-124",
      "Galle-107",
      "Gampaha-102",
      "Hambantota-125",
      "Hatton-128",
      "Head Office-151",
      "Hingurakgoda-126",
      "Horana-127",
      "Ja-Ela-129",
      "Jaffna-130",
      "Kadawatha-101",
      "Kakirawa-135",
      "Kalutara-105",
      "Kandana-136",
      "Kandy-131",
      "Kandy City Office-133",
      "Kilinochchi-134",
      "Kiribathgoda-132",
      "Kotahena-109",
      "Kottawa-104",
      "Kuliyapitiya-137",
      "Kurunegala-110",
      "Maharagama-138",
      "Matara-142",
      "Matugama-143",
      "Metropolitan-141",
      "Monaragala-140",
      "Moratuwa-106",
      "Negombo-103",
      "Nittambuwa-144",
      "Nugegoda-108",
      "Panadura-145",
      "Puttlam-146",
      "Ratnapura-113",
      "Trincomalee-147",
      "Union Place-100",
      "Vavuniya-148",
      "Wattala-150",
      "Wennappuwa-149",
    ],
    "7214-National Development Bank PLC": [
      "Akkaraipattu-094",
      "Akuressa-065",
      "Aluthgama-059",
      "Ambalangoda-047",
      "Ambalantota-048",
      "Ampara-040",
      "Anuradhapura-019",
      "Athurugiriya-071",
      "Awissawella-034",
      "Badulla-018",
      "Balangoda-077",
      "Bandarawela-051",
      "Battaramulla-090",
      "Batticaloa-039",
      "Boralesgamuwa-072",
      "Borella-052",
      "Chavakachcheri-099",
      "Chenkalady-093",
      "Chilaw-010",
      "Chunnakam-062",
      "Dambulla-064",
      "Eheliyagoda-078",
      "Elpitiya-067",
      "Embilipitiya-058",
      "Galle-021",
      "Gampaha-029",
      "Gampola-050",
      "Giriulla-086",
      "Hambantota-057",
      "Handala-088",
      "Hanwella-096",
      "Head Office-000",
      "Head Office-014",
      "Head Office-999",
      "Head Office(Corporare)-900",
      "Head Office(Retail)-100",
      "Hingurakgoda-102",
      "Homagama-030",
      "Horana-027",
      "Islamic Banking Unit-601",
      "Ja Ela-044",
      "Jaffna-037",
      "Jawatta-003",
      "Kadawatha-026",
      "Kaduruwela-060",
      "Kaduwela-055",
      "Kahawatta-084",
      "Kakirawa-083",
      "kalmunai-053",
      "Kalutara-016",
      "Kandana-028",
      "Kandy-002",
      "Kandy City Centre-080",
      "Katana-109",
      "Katunayake-082",
      "Kegalle-017",
      "Kiribathgoda-025",
      "Kochchikade-089",
      "Kohuwala-032",
      "Kotahena-024",
      "Kottawa-111",
      "Kuliyapitiya-042",
      "Kurunegala-007",
      "Maharagama-012",
      "Mahawewa-105",
      "Mahiyangana-075",
      "Malabe-031",
      "Manipai-097",
      "Marine Drive-103",
      "Matale-046",
      "Matara-006",
      "Matugama-045",
      "Minuwangoda-063",
      "Monaragala-070",
      "Moratuwa-015",
      "Mount Lavinia-020",
      "Narahenpita-074",
      "Narammala-091",
      "Natthandiya-095",
      "Navam Mawatha-001",
      "Nawalapitiya-061",
      "Negombo-009",
      "Nelliady-066",
      "Nikaweratiya-069",
      "Nittambuwa-054",
      "Nugegoda-004",
      "Nuwara Eliya-076",
      "Old Moor Street-079",
      "Panadura-035",
      "Pelawatte-022",
      "Pettah-043",
      "Pilimatalawa-049",
      "Piliyandala-023",
      "Pitakotte-087",
      "Puttalam-033",
      "Rajagiriya-005",
      "Ratmalana-073",
      "Ratnapura-013",
      "Thambuttegama -104",
      "Thirunelvely-098",
      "Tissamaharama-092",
      "Trincomalee-038",
      "Uragasmanhandiya-081",
      "Vavuniya-041",
      "Warakapola-101",
      "Wariyapola-056",
      "Wattala-011",
      "Wellawatte-008",
      "Wennappuwa-036",
      "Yakkala-068",
    ],
    "7719-National Savings Bank": [
      "Akkaraipattu-752",
      "Akuressa-055",
      "Alawathugoda-132",
      "Alawwa-742",
      "Aluthgama-105",
      "Ambalangoda-033",
      "Ambalantota-011",
      "Ampara-030",
      "Anamaduwa-746",
      "Angunakolapelessa-760",
      "Anuradhapura-005",
      "Aranayake Piyasa-721",
      "Arayampathy-727",
      "Atchuvely NSB Piyasa-718",
      "Athurugiriya Piyasa-703",
      "Avissawella-057",
      "Badalkumbura-128",
      "Baddegama-734",
      "Badulla-022",
      "Baduraliya-786",
      "Balangoda-091",
      "Bambalapitiya-023",
      "Bandaragama-126",
      "Bandarawela-060",
      "Battaramulla-080",
      "Batticaloa-021",
      "Beliatta-048",
      "Beruwala-028",
      'Bibile"piyasa"-708',
      "Bingiriya-785",
      "Boralesgamuwa-124",
      "Borella-061",
      "Br. Management Division-912",
      "Bulathkohupitiya-710",
      "Bulathsinhala-738",
      "Buttala-741",
      "Chankanai Piyasa-725",
      "Chavakachcheri-073",
      "Chenkaladi-109",
      "Chilaw-007",
      "Chunnakam-072",
      "City-002",
      "Credit Division, (H.L Division)-910",
      "Dambulla-103",
      "Dankotuwa-129",
      "Dehiwala-024",
      "Delgoda-747",
      "Delkanda-119",
      "Deltota-783",
      "Deniyaya-054",
      "Deraniyagala-112",
      "Devinuwara-039",
      "Dickwella-082",
      "Digana-748",
      "Divulapitiya-096",
      "Elpitiya-094",
      "Embilipitiya-013",
      "Eppawala-788",
      "Galagedara-145",
      "Galenbindunuwewa-137",
      "Galewela-755",
      "Galgamuwa-729",
      "Galle-003",
      "Galnewa-058",
      "Gampaha-037",
      "Gampola-074",
      "Ganemulla Piyasa-705",
      "Gelioya-791",
      "Ginigathhena-784",
      "Giriulla-787",
      "Godakawela-133",
      "Habaraduwa-735",
      "Hakmana-062",
      "Hali Ela-751",
      "Hambantota-781",
      "Hanwella-750",
      "Hatton-116",
      "Head Office-001",
      "Hettipola-709",
      "Hikkaduwa-113",
      "Hingurakgoda-076",
      "Homagama-027",
      "Horana-063",
      "Horawpathana-136",
      "Ibbagamuwa-771",
      "IBU (NRFC)-911",
      "Imaduwa-757",
      "Ingiriya-764",
      "Ja-Ela-036",
      "Jaffna-006",
      "Kadawatha-075",
      "Kaduruwela-122",
      "Kaduwela-095",
      "Kahatagasdigiliya-759",
      "Kahathuduwa-104",
      "Kahawatte-737",
      "Kalawana-739",
      "Kalawanchikudy-114",
      "Kalmunai-047",
      "Kalubowila-115",
      "Kalutara-012",
      "Kamburupitiya-086",
      "Kandana-141",
      "Kandy-015",
      "Kandy 2nd-081",
      "Kandy City Center-711",
      "Kantale-762",
      "Karainagar-731",
      "Karapitiya-121",
      "Katubedda-093",
      "Katugastota Piyasa-723",
      "Katunayake-052",
      "Kayts-730",
      "Kebithigollawa-767",
      "Kegalle-018",
      "Kekanadura-775",
      "Kekirawa-014",
      "Kelaniya NSB Piyasa-716",
      "Kilinochchi-019",
      "Kiribathgoda-067",
      "Kiriella-778",
      "Kirindiwela-099",
      "Kochchikade-031",
      "Kodikamam-131",
      "Kollupitiya 2nd-065",
      "Kopay-147",
      "Kotahena-087",
      "Kottawa-102",
      "Kuliyapitiya-008",
      "kurunegala-017",
      "Kuruwita-772",
      "Madampe-761",
      "Mahabage-083",
      "Maharagama-053",
      "Mahiyanganaya-041",
      "Maho-142",
      "Malabe-123",
      "Maligawatta-077",
      "Mallavi-774",
      "Manipay-107",
      "Mannar-049",
      "Marawila-069",
      "Matale-016",
      "Matara-004",
      "Matugama-045",
      "Mawanella-059",
      "Mawathagama-749",
      "Medawachchiya-763",
      "Medirigiriya-776",
      "Meegoda-106",
      "Melsiripura-780",
      "Middeniya Piyasa-724",
      "Minuwangoda-098",
      "Mirigama-079",
      "Monaragala-046",
      "Moratumulla-125",
      "Moratuwa-020",
      "Morawaka-090",
      "Mount Lavinia-068",
      "Mulgampola-127",
      "Mullative-130",
      "Mulleriyawa New Town-733",
      "Mutwal-732",
      "Narahenpita-064",
      "Narammala Piyasa-707",
      "Naththandiya-034",
      "Naula-779",
      "Nawala-111",
      "Nawalapitiya-050",
      "Negombo-009",
      "Nelliady NSB Piyasa-717",
      "Neluwa Piyasa-704",
      "Nikaweratiya-040",
      "Nittambuwa-100",
      "Nivithigala-777",
      "Nochchiyagama-745",
      "Nugegoda-026",
      "Nuwara Eliya-056",
      "Palugamam-753",
      "Panadura-043",
      "Passara-758",
      "PBU - Ampara-909",
      "PBU - Anuradhapura-906",
      "PBU - Eheliyagoda-917",
      "PBU - Galle-903",
      "PBU - Gampaha-908",
      "PBU - Head Office-901",
      "PBU - Jaffna-916",
      "PBU - Kalutara-907",
      "PBU - Kandy-902",
      "PBU - Kegalle-905",
      "PBU - Kurunegala-915",
      "PBU - Matara-904",
      "Peliyagoda-025",
      "Pelmadulla-736",
      "Periyakallar-134",
      "Pettah-051",
      "Pilimathalawa-084",
      "Piliyandala-071",
      "Pitakatte-138",
      "Pitigala-139",
      "Point Pedro-032",
      "Polgahawela-726",
      "Pothuvil-770",
      "Pugoda-790",
      "Pundaluoya-744",
      "Pussellawa-769",
      "Puttalama-044",
      "Puwakaramba Piyasa-719",
      "Raddolugama-728",
      "Ragala-792",
      "Ragama Piyasa-701",
      "Rambukkana-765",
      "Ratnapura-010",
      "Rideegama-782",
      "Rikillagaskada Piyasa-722",
      "Ruwanwella-035",
      "Samanthurai-118",
      "Siyambalanduwa-146",
      "Sooriyawewa-754",
      "Tambuttegama-756",
      "Tangalle NSB Piyasa-713",
      "Thalawakele-078",
      "Thalawathugoda-789",
      "Thamabiluvil-135",
      "Thirunelvely-108",
      "Tissamaharama-097",
      "Trincomalee-089",
      "Udugama-143",
      "Uhana-144",
      "Uragasmanhandiya-110",
      "Urubokka-140",
      "Valaichenai Piyasa-720",
      "Vankalai-773",
      "Vavuniya-088",
      "Veyangoda-092",
      "Wadduwa NSB Piyasa-715",
      "Walasmulla NSB Piyasa-714",
      "Warakapola-042",
      "Wariyapola-766",
      "Wattala-085",
      "Wattegama-768",
      "Weeraketiya NSB Piyasa-712",
      "Weligama-066",
      "Welikada-117",
      "Welimada-101",
      "Wellampitiya Piyasa-706",
      "Wellawatta-070",
      "Wellawaya-740",
      "Wennappuwa-029",
      "WTC Piyasa-702",
      "Yakkala-120",
      "Yatiyantota-743",
    ],
    "7162-Nations Trust Bank PLC": [
      "Akkaraipattu-057",
      "Akuressa-063",
      "Aluthgama-047",
      "Ambalangoda-056",
      "Ambalantota-062",
      "Anuradhapura-039",
      "Avissawella-091",
      "Badulla-059",
      "Balangoda-064",
      "Bandaragama-072",
      "Bandarawela-032",
      "Battaramulla-010",
      "Batticaloa-034",
      "Boralasgamuwa-075",
      "Borella-015",
      "Card Center-400",
      "Central Clearing-000",
      "Chilaw-043",
      "Colpetty-002",
      "Corporate-006",
      "Crescat-022",
      "Dehiwala-023",
      "Deniyaya-065",
      "Dharmapala Mawatha-011",
      "Digana-073",
      "Elpitiya-082",
      "Embilipitiya-061",
      "Galle-029",
      "Gampaha-018",
      "Gampola-088",
      "Giriulla-083",
      "Gothatuwa-077",
      "Hambantota-058",
      "Havelock Town-025",
      "Head Office-999",
      "Hikkaduwa-087",
      "Homagama-031",
      "Horana-036",
      "Ja-Ela-060",
      "Jaffna-035",
      "Kadawatha-021",
      "Kaduruwela-045",
      "Kaduwela-070",
      "Kalmunai-037",
      "Kandy-004",
      "Kandy City Center-093",
      "Karapitiya-067",
      "Katugastota-069",
      "Kegalle-079",
      "Kiribathgoda-016",
      "Kohuwala-054",
      "Kohuwala-504",
      "Kotahena-019",
      "Kottawa-076",
      "Kuliyapitiya-055",
      "Kurunegala-012",
      "Liberty Plaza-500",
      "Mahabage-009",
      "Maharagama-013",
      "Malabe-038",
      "Matale-092",
      "Matara-028",
      "Matugama-066",
      "Mawathagama-090",
      "Minuwangoda-086",
      "Monaragala-074",
      "Moratuwa-014",
      "Mount Lavinia-052",
      "Mount Lavinia-502",
      "Narahenpita-081",
      "Nawala-027",
      "Nawam Mawatha-024",
      "Negombo(C.S.P.)-007",
      "Nelliady-044",
      "Nittambuwa-085",
      "NTB.Head Office,-001",
      "Nugegoda-053",
      "Nugegoda-503",
      "Nuwara Eliya-042",
      "Old Moor Street-071",
      "Panadura-017",
      "Peradeniya-026",
      "Pettah-Bankshall Street -046",
      "Pettah-Main Street -008",
      "Piliyandala-040",
      "Rajagiriya-068",
      "Ratnapura-041",
      "Sri Sangharaja Mw.-003",
      "Tangalle-089",
      "Thalawathugoda-030",
      "Tissamaharama-080",
      "Trincomalee-049",
      "Vavuniya-033",
      "Ward Place-020",
      "Wariyapola-078",
      "Wattala-051",
      "Wattala-501",
      "Weligama-084",
      "Wellawatte-005",
      "Wennappuwa-048",
      "World Trade Centre-050",
    ],
    "7311-Pan Asia Banking Corporation PLC": [
      "Akkaraipaththu-060",
      "Akuressa-072",
      "Ambalangoda-041",
      "Ambalanthota-053",
      "Anuradhapura-032",
      "Badulla-045",
      "Balangoda-062",
      "Bambalapitiya-009",
      "Bandarawela-048",
      "Battaramulla-063",
      "Batticaloa-040",
      "Borella-031",
      "Chilaw-036",
      "Chunnakam-061",
      "Colombo Gold Centre-078",
      "Dam Street-019",
      "Dambulla-049",
      "Dankotuwa-083",
      "Dehiwela-015",
      "Embilipitiya-038",
      "Galewela-071",
      "Galle-025",
      "Gampaha-011",
      "Gampola-030",
      "Hatton-075",
      "Head Office-999",
      "Homagama-076",
      "Horana-077",
      "Internationl Remittance-814",
      "Ja-Ela-066",
      "Jaffna-037",
      "Kadawatha-026",
      "Kaduruwela-052",
      "Kaduwela-081",
      "Kalmunai-042",
      "Kalubowila-047",
      "Kalutara-033",
      "Kandy-005",
      "Kandy City Centre-044",
      "Kanthankudy-057",
      "Katugastota-020",
      "Kegalle-027",
      "Kekirawa-067",
      "Kilinochchi-043",
      "Kiribathgoda-054",
      "Kirulapana-022",
      "Kollupitiya-003",
      "Kotahena-014",
      "Kottawa-080",
      "Kuliyapitiya-046",
      "Kundasale-058",
      "Kurunegala-012",
      "Maharagama-023",
      "Malabe-035",
      "Matale-039",
      "Matara-013",
      "Mawanella-082",
      "Metro-001",
      "Minuwangoda-069",
      "Monaragala-059",
      "Moratuwa-024",
      "Narahenpita-021",
      "Nawala-079",
      "Negombo-010",
      "Nelliady-056",
      "Nugegoda-008",
      "Old Moor Street-018",
      "Panadura-017",
      "Panchikawatte-002",
      "Peradeniya-051",
      "Pettah-004",
      "Pilimathalawa-065",
      "Piliyandala-055",
      "Puttalama-064",
      "Rajagiriya-006",
      "Ratmalana-050",
      "Ratnapura-007",
      "Tangalle-074",
      "Thalawathugoda-068",
      "Trincomalee-073",
      "Vavuniya-034",
      "Warakapola-070",
      "Wattala-016",
      "Wellawatta-029",
      "Wennappuwa-028",
    ],
    "7135-Peoples Bank": [
      "Addalachchene-228",
      "Ahangama-188",
      "Akkaraipattu-063",
      "Akurana-153",
      "Akuressa-117",
      "Alawathugoda-294",
      "Alawwa-149",
      "Aluthgama-084",
      "Ambalangoda-035",
      "Ambalantota-072",
      "Ampara-015",
      "Anamaduwa-267",
      "Angunakolapalessa-205",
      "Ankumbura-183",
      "Anuradhapura-008",
      "Anuradhapura-Nuwarawewa-220",
      "Aralaganwila-253",
      "Aranayake-248",
      "Atchchuvely-107",
      "Avissawella-029",
      "Badalkubura-347",
      "Baddegama-087",
      "Badulla-010",
      "Badulla-Muthiyangana-269",
      "Baduraliya-283",
      "Bakamuna-242",
      "Balangoda-017",
      "Balapitiya-154",
      "Bambalapitiya-310",
      "Bandaragama-121",
      "Bandarawela-037",
      "Batapola-234",
      "Battaramulla-208",
      "Batticaloa-075",
      "Batticaloa Town-113",
      "Beliatta-244",
      "Beruwala-311",
      "Bibile-011",
      "Bingiriya-172",
      "Bogawanthalawa-354",
      "Boralanda-209",
      "Boralesgamuwa-348",
      "Borella-078",
      "Borella Town-320",
      "Bulathkohupitiya-252",
      "Bulathsinhala-161",
      "Buttala-147",
      "Capricon-326",
      "Card Center-600",
      "CCD-999",
      "Chankanai-108",
      "Chavakachcheri-110",
      "Cheddikulam-356",
      "Chenkalady-227",
      "Chilaw-024",
      "Chunnakam-109",
      "Dam Street-297",
      "Dambulla-138",
      "Dankotuwa-291",
      "Davulagala-206",
      "Dehiattakandiya-330",
      "Dehiowita-293",
      "Dehiwala-019",
      "Dehiwela (Galle Rd.)-337",
      "Delgoda-118",
      "Deltota-257",
      "Dematagoda-071",
      "Deniyaya-132",
      "Deraniyagala-180",
      "Devinuwara-243",
      "Dickwella-135",
      "Diyatalawa-151",
      "Duke Street-001",
      "Eheliyagoda-085",
      "Elpitiya-073",
      "Embilipitiya-045",
      "Eppawela-170",
      "Eravur-123",
      "Galagedera-114",
      "Galenbindunuwewa-177",
      "Galewela-115",
      "Galgamuwa-184",
      "Galigamuwa-185",
      "Galkiriyagama-301",
      "Galle Fort-013",
      "Galle Main Street-169",
      "Galnewa-179",
      "Gampaha-026",
      "Gampola-018",
      "Gandara-307",
      "Ganemulla-332",
      "Gangodawila-097",
      "Ginigathhena-302",
      "Ginthupitiya-298",
      "Girandurukotte-268",
      "Giriulla-092",
      "Godakawela-245",
      "Gonagaldeniya-238",
      "Grandpass-126",
      "Habarana-203",
      "Hakmana-130",
      "Haldummulla-195",
      "Haliela-225",
      "Hambantota-007",
      "Hanguranketha-022",
      "Hanwella-229",
      "Haputale-216",
      "Hasalaka-140",
      "Hataraliyadda-341",
      "Hatton-186",
      "Head Quarters-204",
      "Hemmathagama-221",
      "Hettipola-144",
      "Hikkaduwa-136",
      "Hingurakgoda-006",
      "Homagama-049",
      "Horana-041",
      "Horowpathana-218",
      "Hyde park Corner-025",
      "Ibbagamuwa-207",
      "Imaduwa-247",
      "Ingiriya-300",
      "International Division-004",
      "Ja Ela-239",
      "Jaffna Kannathiddy-284",
      "Jaffna Main Street-104",
      "Jaffna Stanley Road-030",
      "Jaffna University-162",
      "Kadawatha-273",
      "Kadugannawa-159",
      "Kaduwela-196",
      "Kahatagasdigiliya-051",
      "Kahawatte-155",
      "Kalawana-235",
      "Kallar-339",
      "Kalmunai-023",
      "Kalpitiya-125",
      "Kaltota-289",
      "Kalutara-039",
      "Kaluwanchikudy-190",
      "Kamburupitiya-133",
      "Kandana-175",
      "Kandeketiya-250",
      "Kandy-003",
      "Kandy City Centre-357",
      "Kankasanthurai-031",
      "Kantale-090",
      "Karaitivu-223",
      "Karapitiya-343",
      "Kataragama-168",
      "Kattankudy-065",
      "Katubedda-313",
      "Katugastota-089",
      "Katunayake-276",
      "Kayts-105",
      "Kebithigollawa-150",
      "Kegalle-027",
      "Kegalle Bazaar-299",
      "Kehelwatte-259",
      "Kekirawa-042",
      "Kelaniya-055",
      "Keppetipola-240",
      "Kesbewa-327",
      "Kilinochchi-048",
      "Kinniya-094",
      "Kiribathgoda-237",
      "Kiriella-266",
      "Kirindiwela-202",
      "Kirulapana-319",
      "Kobeigane-281",
      "Kochchikade-142",
      "Koggala-329",
      "Kokkaddicholai-342",
      "Kollupitiya Co-op House-210",
      "Kolonnawa-194",
      "Koslanda-260",
      "Kotahena-308",
      "Kotikawatte-098",
      "Kotiyakumbura-355",
      "Kottawa-328",
      "Kudawella-288",
      "Kuliyapitiya-028",
      "Kurunegala-012",
      "Kurunegala Maliyadeva-226",
      "Kurunegala-Ethugalpura-334",
      "Kuruwita-263",
      "Liberty Plaza-309",
      "Lucky Plaza-331",
      "Lunugala-251",
      "Madampe-215",
      "Maggona-282",
      "Maha - Oya-181",
      "Mahara-217",
      "Maharagama-306",
      "Mahawewa-303",
      "Mahiyangana-058",
      "Maho-052",
      "Majestic City-200",
      "Makandura-137",
      "Malwana-191",
      "Malwatta Road-312",
      "Mankulam-165",
      "Mannar-044",
      "Maradana-236",
      "Marandagahamula-100",
      "Marawila-322",
      "Maruthamunai-346",
      "Maskeliya-178",
      "Matale-002",
      "Matara Dharmapala Mawatha-152",
      "Matara Uyanwatta-032",
      "Mathugama-070",
      "Mawanella-069",
      "Mawathagama-199",
      "Medagama-258",
      "Medawachchiya-096",
      "Medirigiriya-231",
      "Meegalewa-246",
      "Melsiripura-344",
      "Menikhinna-157",
      "Mid City-176",
      "Middeniya-265",
      "Minuwangoda-021",
      "Mirigama-198",
      "Monaragala-068",
      "Moratumulla-290",
      "Moratuwa-091",
      "Morawaka-060",
      "Mount Lavinia-336",
      "Mudalige Mawatha-046",
      "Mulativu-020",
      "Murunkan-166",
      "Muttur-095",
      "Mutuwal-214",
      "Narahenpita-119",
      "Narammala-082",
      "Nattandiya-083",
      "Naula-146",
      "Nawalapitiya-053",
      "Neboda-249",
      "Negombo-034",
      "Nelliady-106",
      "Nikeweratiya-124",
      "Nildandahinna.-127",
      "Nintavur-296",
      "Nittambuwa-278",
      "Nivitigala-192",
      "Nochchiyagama-171",
      "Nugegoda-174",
      "Nugegoda City-335",
      "Nuwara Eliya-134",
      "Oddamavady-340",
      "Olcott Mawatha-275",
      "Overseas Customers Unit-796",
      "Padaviya-043",
      "Pallebedda-349",
      "Pallepola-241",
      "Pamunugama-318",
      "Panadura-148",
      "Panadura Town-321",
      "Panwila-211",
      "Paranthan-111",
      "Passara-116",
      "Pelawatte-261",
      "Pelmadulla-160",
      "Peradeniya-057",
      "Pettah-139",
      "Pilimatalawa-256",
      "Piliyandala-103",
      "Piliyandala City-359",
      "Pitakotte-279",
      "Point Pedro-285",
      "Polgahawela-059",
      "Polonnaruwa-005",
      "Polonnaruwa Town-232",
      "Polpithigama-360",
      "Poojapitiya-358",
      "Pothuhera-280",
      "Potuvil-164",
      "Pugoda-093",
      "Pulmudai-352",
      "Pundaluoya-173",
      "Pussellawa-274",
      "Puttalam-009",
      "Queens-033",
      "Ragala-036",
      "Ragama-316",
      "Rakwana-129",
      "Rambukkana-101",
      "Ranna-345",
      "Ratmalana-080",
      "Ratnapura-088",
      "Ratnapura Town-317",
      "Ratthota-128",
      "Ridigama-193",
      "Rikillagaskada-353",
      "Ruwanwella-081",
      "Sainthamaruthu-338",
      "Samanthurai-064",
      "Sea Street-277",
      "Seeduwa-324",
      "Senkadagala-158",
      "Serunuwara-233",
      "Sri Sangaraja Mawatha-056",
      "Suduwella-143",
      "Suriyawewa-264",
      "Talawa-315",
      "Talawakele-038",
      "Talgaswela-272",
      "Tambuttegama-219",
      "Tanamalwila-230",
      "Tangalle-067",
      "Teldeniya-112",
      "Thambala-351",
      "Thimbirigasyaya-086",
      "Thirukkovil-224",
      "Thulhiriya-270",
      "Tissamaharama-061",
      "Town Hall, Colombo-167",
      "Trincomalee-066",
      "Trincomalee Town-255",
      "Udapussellawa-292",
      "Udawalawe-295",
      "Udugama-131",
      "Uhana-189",
      "Ukuwela-201",
      "Union Place-014",
      "Uragasmanhandiya-197",
      "Urubokka-271",
      "Uva-Paranagama-156",
      "Valaichechenai-102",
      "Vavuniya-040",
      "Velvetiturai-141",
      "Veyangoda-079",
      "Wadduwa-262",
      "Walasgala-304",
      "Walasmulla-120",
      "Wanduramba-325",
      "Warakapola-054",
      "Wariyapola-163",
      "Wattala-222",
      "Wattegama-074",
      "Weeraketiya-350",
      "Weligama-077",
      "Welikanda-254",
      "Welimada-016",
      "Wellawatte-145",
      "Wellawaya-062",
      "Wennappuwa-076",
      "Wilgamuwa-122",
      "Yakkala-333",
      "Yatiyantota-047",
    ],
    "7922-People's Leasing & Finance PLC": [
      "Akuressa-002",
      "Ambalangoda-003",
      "Ambalantota-004",
      "Ampara-005",
      "Anuradhapura-006",
      "Avissawella-007",
      "Badulla-008",
      "Balangoda-009",
      "Bandarawela-010",
      "Battaramulla-011",
      "Batticaloa-012",
      "Bentota-013",
      "Chilaw-014",
      "Chunnakam-015",
      "Dambulla-017",
      "Dehiwala-018",
      "Deniyaya-019",
      "Digana-020",
      "Elpitiya-021",
      "Embilipitiya-022",
      "Galle-023",
      "Gampaha-024",
      "Gampola-025",
      "Giriulla-026",
      "Grandpass-027",
      "Hambantota-028",
      "Hatton-029",
      "Havelock City-030",
      "Head Office-001",
      "Homagama-031",
      "Horana-032",
      "Ja-Ela-033",
      "Jaffna-034",
      "Kadawatha-035",
      "Kaduwela-036",
      "Kalawana-037",
      "Kalmunai-AlSafa-038",
      "Kalutara-039",
      "Kaluwanchikudy-040",
      "Kandy-041",
      "Kandy-AlSafa-042",
      "Kanthale-043",
      "Kattankudy-AlSafa-044",
      "Kegalle-045",
      "Kekirawa-046",
      "Kelaniya-047",
      "Kilinochchi-048",
      "Kirindiwela-049",
      "Kollupitiya-016",
      "Kuliyapitiya-050",
      "Kurunegala-051",
      "Mahaiyawa-052",
      "Maharagama-053",
      "Mahiyanganaya-054",
      "Mannar-055",
      "Matale-056",
      "Matara-057",
      "Mathugama-058",
      "Medawachchiya-059",
      "Melsiripura-060",
      "Metropolitan Office-061",
      "Minuwangoda-062",
      "Mirigama-063",
      "Monaragala-064",
      "Moratuwa-065",
      "Mutur-AlSafa-066",
      "Nawalapitiya-067",
      "Negombo-068",
      "Neluwa-069",
      "Nittambuwa-070",
      "Nugegoda-071",
      "Nuwara Eliya-072",
      "Panadura-073",
      "Pelmadulla-074",
      "Pettah-075",
      "Pilimathalawa-076",
      "Piliyandala-077",
      "Polonnaruwa-078",
      "Puttalam-AlSafa-079",
      "Ratnapura-080",
      "Tangalle-081",
      "Thambuttegama-082",
      "Tissamaharama-083",
      "Trincomalee-084",
      "Union Place-Alsafa-085",
      "Vavuniya-086",
      "Ward Place-087",
      "Wariyapola-088",
      "Wattala-089",
      "Welimada-090",
      "Wellawatte-091",
      "Wellawaya-092",
      "Wennappuwa-093",
    ],
    "7296-Public Bank": [
      "Galle-001",
      "Head Office-000",
      "Head Office-001",
      "Head Office-999",
      "Nawala-001",
    ],
    "7755-Regional Development Bank": [
      "Agalawatte-103",
      "Agarapathana-617",
      "Ahangama-243",
      "Akkaraipaththu-805",
      "Akmeemana-222",
      "Akuressa-204",
      "Alawwa-304",
      "Ambalantota-208",
      "Ambanpola-331",
      "Ampara-801",
      "Anamaduwa-315",
      "Angunukolapalassa-209",
      "Aralaganwila-423",
      "Aranayaka-506",
      "Awissawella-127",
      "Badalkumbura-711",
      "Baddegama-217",
      "Badulla-705",
      "Baduraliya-114",
      "Bakamoona-414",
      "Balangoda-514",
      "Balapitiya-249",
      "Bandarawela-715",
      "Barawakumbuka-240",
      "Batapola-213",
      "Batticaloa-811",
      "Beliatta-211",
      "Beruwala-107",
      "Bibile-721",
      "Bogahakumbura-720",
      "Bogaswewa-907",
      "Bowatte-328",
      "Bulathkohupitiya-510",
      "Bulathsinghala-101",
      "Buttala-701",
      "Chenkalady-813",
      "Chilaw-313",
      "Chunnakam-904",
      "City - Matara-233",
      "Dambulla-620",
      "Danture-605",
      "Daulagala-627",
      "Dehiatthakandiya-802",
      "Dehiovita-529",
      "Deiyandara-203",
      "Deniyaya-226",
      "Deraniyagala-511",
      "Devinuwara-254",
      "Dewalegama-509",
      "Dikwella-247",
      "District Office - Galle-298",
      "District Office - Hambantota-297",
      "District Office - Matara-299",
      "Divulapitiya-123",
      "Diyathalawa-724",
      "Dodangoda-112",
      "Dritrict Office Polonnaruwa-498",
      "Dummalasooriya-305",
      "Economic Centre-424",
      "Eheliyagoda-518",
      "Elpitiya-212",
      "Embilipitiya-515",
      "Erathna-523",
      "Eraur-812",
      "Galamuna-418",
      "Galenbindunuwewa-415",
      "Galewela-621",
      "Galgamuwa-312",
      "Galle-228",
      "Galnewa-405",
      "Gampaha-116",
      "Gampaha District Office-198",
      "Gampola-601",
      "Gandara-206",
      "Ginigathena-613",
      "Girandurukotte-719",
      "Giriulla-320",
      "Godakawela-522",
      "Gonagalapura-215",
      "Gonapathirawa-416",
      "Goonapola-105",
      "Hakmana-201",
      "Haldummulla-718",
      "Hambantota-238",
      "Hanguranketha-626",
      "Haputhale-712",
      "Hataraliyadda-603",
      "Head Office-001",
      "Hedeniya-630",
      "Hemmathagama-516",
      "Hikkaduwa-244",
      "Hingurakgoda-413",
      "Hingurana-804",
      "Homagama-125",
      "Horana-109",
      "HQB-329",
      "Ibbagamuwa-321",
      "Imaduwa-216",
      "Ingiriya-111",
      "Jaffna-905",
      "J-Ela-132",
      "Kaduruwela-421",
      "Kahatagasdigiliya-404",
      "Kahawatta-526",
      "Kalauwanchikudi-818",
      "Kalawana-520",
      "Kalmunai-806",
      "Kalutara-115",
      "Kalutara District Office-199",
      "Kaluwella-252",
      "Kamburugamuwa-225",
      "Kamburupitiya-227",
      "Kanagarayankulam-902",
      "Kandaketiya-708",
      "Kandy-632",
      "Kandy Marketing Centre-612",
      "Kanthale-814",
      "Karandeniya-223",
      "Karapitiya-248",
      "Kathankudi-816",
      "Katugastota-615",
      "Katuwana-210",
      "Kegalle-501",
      "Kegalle District Office-599",
      "Kekanadura-207",
      "Kekirawa-422",
      "Kelaniya - Head Quarter-134",
      "Kilinochchi-906",
      "Kiriella-530",
      "Kirimetiyana-317",
      "Kirinda-245",
      "Kirindiwela-131",
      "Kithulgala-507",
      "Kokkadichcholai-819",
      "Kolonna-517",
      "Kolonnawa-126",
      "Kotagala-624",
      "Kotiyakumbura-527",
      "Kuliyapitiya-301",
      "Kurunegala-311",
      "Kurunegala District Office-399",
      "Kuruwita-524",
      "Laggala-622",
      "Lunugala-717",
      "Lunugamwehera-219",
      "Madulla-726",
      "Mahaoya-807",
      "Mahawewa-325",
      "Mahiyanganaya-709",
      "Maho-319",
      "Mampuri-324",
      "Manampitiya-417",
      "Mannar-903",
      "Marassana-604",
      "Matale-619",
      "Mathugama-121",
      "Mawanella-504",
      "Mawarala-236",
      "Mawaramandiya-117",
      "Mawathagama-309",
      "Medagama-702",
      "Medawachchiya-407",
      "Medirigiriya-411",
      "Meegahakiula-716",
      "Meegahathenna-113",
      "Meerigama-119",
      "Melsiripura-330",
      "Menikhinna-625",
      "Middeniya-246",
      "Mihinthale-401",
      "Millaniya-104",
      "Minuwangoda-118",
      "Mirissa-251",
      "Miriswaththa-133",
      "Monaragala-703",
      "Moragahahena-120",
      "Moranthuduwa-106",
      "Morawaka-237",
      "Morayaya-607",
      "Mundel-322",
      "Muthtur-820",
      "Narammala-326",
      "Nattandiya-316",
      "Naula-628",
      "Nawagattegama-323",
      "Nawalapitiya-629",
      "Negombo-122",
      "Nelumdeniya-519",
      "Neluwa-235",
      "New Town - Anuradhapura-419",
      "Nikaweratiya-307",
      "Nildandahinna-616",
      "Nintavur-810",
      "Nittambuwa-124",
      "Nivithigala-525",
      "Nuwara Eliya-610",
      "Palakuda-314",
      "Pamburana-250",
      "Panadura-108",
      "Panduwasnuwara-303",
      "Pannala-302",
      "Passara-706",
      "Pelmadulla-513",
      "Peradeniya-633",
      "Piliyandala-128",
      "Pitabaddera-220",
      "Pitagaldeniya-502",
      "Pitigala-214",
      "Polonnaruwa-410",
      "Polpithigama-327",
      "Poondaluoya-614",
      "Pothuhera-306",
      "Pothupitiya-531",
      "Pothuvil-808",
      "Provincial Office - Central-003",
      "Provincial Office - Central-600",
      "Provincial Office - North Central-400",
      "Provincial Office - Sabaragamuwa-500",
      "Provincial Office - Southern-200",
      "Provincial Office - Uva-700",
      "Provincial Office - Western-100",
      "Pujapitiya-609",
      "Pulasthigama-412",
      "Pulungupitiya-534",
      "Puttlam-318",
      "Puttlam District Office-398",
      "Ragama-129",
      "Rakwana-528",
      "Rambewa-409",
      "Rambukkana-503",
      "Ranna-242",
      "Rathnapura-512",
      "Rattota-623",
      "Rideegama-308",
      "Rideemaliyadda-713",
      "Rikillagaskada-611",
      "Ruwanwella-508",
      "Sammanthurai-803",
      "Santha Anapura-332",
      "Sevanapitiya-425",
      "Sewanagala-725",
      "Siripura-420",
      "Siyambalanduwa-723",
      "Sooriyawewa-224",
      "Sri Palabaddala-533",
      "Tangalle-234",
      "Teldeniya-608",
      "Thalawa-406",
      "Thalgaswala-221",
      "Thambuththegama-403",
      "Thanamalvila-704",
      "Thihagoda-232",
      "Thirappane-408",
      "Tissamaharama-218",
      "Town Branch - Anuradhapura-402",
      "Trincomalee-817",
      "Udawela-602",
      "Ududumbara-618",
      "Udugama-241",
      "Uhana-809",
      "Uragasmanhandiya-229",
      "Urubokka-202",
      "Uva Maligathenna-722",
      "Uvaparanagama-714",
      "Valachenai-815",
      "Vavuniya-901",
      "Wadduwa-130",
      "Walagedara-102",
      "Walasmulla-239",
      "Warakagoda-110",
      "Warakapola-505",
      "Warapitiya-253",
      "Wariyapola-310",
      "Wattegama-606",
      "Wayamba Provincial Office-300",
      "Weerakatiya-231",
      "Weligama-205",
      "Weligepola-532",
      "Welimada-707",
      "wellawaya-710",
      "Wilgamuwa-631",
      "Yakkalamulla-230",
      "Yatiyantota-521",
    ],
    "7278-Sampath Bank PLC": [
      "2nd Branch Batticaloa-139",
      "Ahangama-182",
      "Akkaraipattu-111",
      "Akuressa-179",
      "Alawwa PBC-053",
      "Aluthgama-079",
      "Ambalantota-104",
      "Ambalongoda-072",
      "Ampara-062",
      "Anamabuwa-143",
      "Anuradhapura New Town-168",
      "Anuradhapura Super Branch-021",
      "Aralangawila-154",
      "Athurugiriya PBC-067",
      "Attidiya-089",
      "Avissawella-022",
      "Baddegama-118",
      "Badulla-093",
      "Balangoda-097",
      "Bambalapitiya-011",
      "Bandaragama-059",
      "Bandarawela-046",
      "Battaramulla-061",
      "Batticaloa-107",
      "Beliatta-180",
      "Bibile-161",
      "Boralesgamuwa-142",
      "Borella-004",
      "Borella Super-218",
      "Buttala-145",
      "Card Centre-996",
      "Central Clearing Department-993",
      "Chankanai-164",
      "Chavakachcheri-169",
      "Chenkalady-121",
      "Chilaw-108",
      "Chunnakam-128",
      "City Office-001",
      "Colombo Super-175",
      "Dambulla-090",
      "Dankotuwa-196",
      "Dehiattakandiya-167",
      "Dehiwala-017",
      "Delgoda-202",
      "Deniyaya-014",
      "Deraniyagala PBC-049",
      "Dickwella-216",
      "Digana PBC-085",
      "Divulapitiya-198",
      "Eheliyagoda-020",
      "Elpitiya-204",
      "Embilipitiya-043",
      "Embuldeniya-114",
      "Fort-012",
      "Galewela-190",
      "Galle-035",
      "Galle Bazaar-159",
      "Gampaha-016",
      "Gampaha Super-212",
      "Gampola-101",
      "Ganemulla PBC-078",
      "Gangodawila-135",
      "Giriulla-095",
      "Godakawela-225",
      "Gothatuwa New Town-173",
      "Grandpass-127",
      "Gregorys Road PBC-070",
      "Habaraduwa-181",
      "Hanwella-137",
      "Harbour-View PBC-058",
      "Hatton-080",
      "Head Office-999",
      "Headquarters-029",
      "Heerassagala-220",
      "Hendala-096",
      "Hettipola-187",
      "Hikkaduwa-229",
      "Hingurakgoda-110",
      "Homagama-069",
      "Horana-057",
      "Ingiriya-140",
      "Ja-Ela-098",
      "Jaffna-120",
      "Kaburupitiya-206",
      "Kadawatha-060",
      "Kaduruwela-038",
      "Kaduwela-162",
      "Kahatagasdigiliya-203",
      "Kalawana-041",
      "Kalmunai-112",
      "Kalutara-050",
      "Kaluwanchikudy-125",
      "Kandana-076",
      "Kandy City Centre-123",
      "Kandy Metro-100",
      "Kandy Super-007",
      "Kantale-172",
      "Karagampitiya-210",
      "Karapitiya-141",
      "Kattankudy-115",
      "Katugastota-032",
      "Kayts-171",
      "Kegall-064",
      "Kekirawa-149",
      "Kelaniya-227",
      "Kesbewa-224",
      "Keselwatta-151",
      "Kilinochchi-148",
      "Kinniya-177",
      "Kiribathgoda-005",
      "Kiribathgoda-200",
      "Kirindiwela PBC-083",
      "Kirulapone-117",
      "Kochchikade-165",
      "Kohuwela-094",
      "Kollupitiya-134",
      "Kotahena-037",
      "Kottawa -052",
      "Kuliyapitiya-023",
      "Kundasale-133",
      "Kurunegala-006",
      "Kurunegala Metro-215",
      "Madampe-189",
      "Maharagama-013",
      "Maharagama Super-092",
      "Mahiyanganaya-056",
      "Maho-197",
      "Main Street-042",
      "Makola-207",
      "Malabe-039",
      "Mallavi-174",
      "Manipay-147",
      "Mannar-119",
      "Maradana-144",
      "Marandagahamula-183",
      "Marawila-194",
      "Matale-025",
      "Matara-010",
      "Matara Bazaar-153",
      "Mattegoda-176",
      "Matugama-106",
      "Mawanella-160",
      "Mawathagama-109",
      "Menikhinna-184",
      "Middeniya-158",
      "Minuwangoda-065",
      "Mirigama-086",
      "Monaragala-074",
      "Moratumulla-155",
      "Moratuwa-031",
      "Morawaka-015",
      "Mount Lavinia-199",
      "Muttur-208",
      "Mutwal-193",
      "Narahenpita-040",
      "Narammala-099",
      "Nattandiya-132",
      "Nawala-082",
      "Nawala Koswatta-223",
      "Nawalapitiya-195",
      "Nawam Mawatha-009",
      "Negombo-024",
      "Negombo 2nd-088",
      "Nelliady-129",
      "Neluwa PBC-054",
      "Nikaweratiya-102",
      "Ninthavur-185",
      "Nittambuwa-071",
      "Nochchiyagama-138",
      "Nugegoda-003",
      "Nuwara Eliya-084",
      "Oddamavady-124",
      "Old Moor Street-027",
      "Orugodawatte-214",
      "Padukka-192",
      "Panadura-026",
      "Panadura Wekada-047",
      "Panchikawatte-191",
      "Pannala-166",
      "Pannipitiya-087",
      "Passara-146",
      "Pelawatte PBC-063",
      "Peliyagoda-136",
      "Pelmadulla-103",
      "Peradeniya PBC-051",
      "Pettah-002",
      "Pilimatalawa-150",
      "Piliyandala-019",
      "Pitakotte-091",
      "Platinum Plus-131",
      "Polgahawela-228",
      "Poojapitiya-221",
      "Pottuvil-130",
      "Prince Street-217",
      "Pussellawa-152",
      "Puttalam-156",
      "Ragama PBC-073",
      "Rajagiriya-122",
      "Rambukkana-188",
      "Rathnapura-033",
      "Ratmalana-018",
      "Ratnapura-226",
      "Rikillagaskada-163",
      "Ruwanwella-201",
      "Sainthamaruthu-126",
      "Sampath Viswa-929",
      "Seeduwa-213",
      "Sooriyawewa-157",
      "Talahena-211",
      "Tangalle-116",
      "Thalawakele-222",
      "Thalawathugoda-178",
      "Thambuttegama (PBC)-048",
      "Thimbirigasyaya-034",
      "Thirunelvely-186",
      "Tissamaharama-028",
      "Trincomalee-066",
      "Vavunia-055",
      "Vavuniya Metro-170",
      "veyangoda PBC-077",
      "Wadduwa PBC-075",
      "Warakapola-205",
      "Wariyapola (PBC)-044",
      "Wattala-008",
      "Wattegama-105",
      "Weligama-209",
      "Welimada-081",
      "Wellampitiya (PBC)-045",
      "Wellawatte Super-036",
      "Wellawaya-113",
      "Wennappuwa-030",
      "World Trade Center-219",
      "Yakkala PBC-068",
    ],
    "7728-Sanasa Development Bank": [
      "1st Colombo City-001",
      "Akkeripattu-074",
      "Akurassa-008",
      "Aluthgama-080",
      "Ambalangoda-030",
      "Ambalanthota-023",
      "Ampara-039",
      "Anamaduwa-050",
      "Angunakolapalassa-051",
      "Anuradhapura-017",
      "Aralaganvila-052",
      "Badulla-044",
      "Bandarawela-092",
      "Battaramulla-003",
      "Batticaloa-029",
      "Buttala-062",
      "Chilaw-011",
      "Chunnakam-089",
      "Dambulla-035",
      "Dehiattakandiya-058",
      "Dehiwala-086",
      "Deniyaya-049",
      "Deraniyagala-057",
      "Ekala-087",
      "Elpitiya-064",
      "Embilipitiya-004",
      "Galenbidunuwewa-053",
      "Galle-032",
      "Gampaha-082",
      "Gampola-048",
      "Giriulla-033",
      "Hatharaliyadda-076",
      "Hingurna-077",
      "Horana-005",
      "Jaffna-042",
      "Kaduwela-078",
      "Kalawanchikudi-059",
      "Kalmuani-022",
      "Kalutara-025",
      "Kandy-010",
      "Kanthale-073",
      "Karapitiya-007",
      "Katuwana-067",
      "Kegalle-002",
      "Kekirawa-071",
      "Kilinochchi-069",
      "Kiribathgoda-006",
      "Kirulapona-056",
      "Kuliyapitiya-026",
      "Kurunegala-020",
      "Mahabage-085",
      "Maharagama-081",
      "Maho-037",
      "Malabe-084",
      "Manaragala-013",
      "Mannar-090",
      "Mapalagama-046",
      "Matale-009",
      "Matara-031",
      "Mathugama-047",
      "Mawanella-068",
      "Medawachchiya-040",
      "Moratuwa-075",
      "Muthur-041",
      "Nanatan-043",
      "Narammala-079",
      "Negombo-027",
      "Nochchiyagama-065",
      "Nuwara Eliya-088",
      "Padavi Parakramapura-070",
      "Pilimathalawa-055",
      "Polonnaruwa-028",
      "Pottuvil-045",
      "Rambukkana-034",
      "Rathnapura-015",
      "Rikillagaskada-019",
      "Ruwanwella-014",
      "Sahasapura-018",
      "Samanthurei-060",
      "Sanasa Development Bank Head Office-999",
      "Siyabalanduwa-061",
      "Thalawa-083",
      "Thambuththegama-036",
      "Tissamaharama-091",
      "Trincomalle-021",
      "Uhana-072",
      "Valachchena-063",
      "Vavuniya-012",
      "Warakapola-016",
      "Wariyapola-054",
      "Wennappuwa-038",
      "Yakkalamulla-066",
    ],
    "7782-Senkadagala Finance PLC": ["Head Office-001"],
    "7287-Seylan Bank PLC": [
      "Akkaraipatthu-116",
      "Akuressa-100",
      "Ambalangoda-024",
      "Ambalantota-105",
      "Ampara-091",
      "Anuradhapura-021",
      "Aralaganwila-129",
      "Athurugiriya-163",
      "Attidiya-041",
      "Awissawella-075",
      "Badulla-026",
      "Baduraliya-145",
      "Balangoda-020",
      "Bambalapitiya-139",
      "Bandaragama-054",
      "Bandarawela-046",
      "Battaramulla-101",
      "Batticaloa-073",
      "Beliatta-065",
      "Beruwala-121",
      "Bogawanthalawa-059",
      "Boralesgamuwa-034",
      "Borella-082",
      "Bowatta-137",
      "Central Processing Unit-996",
      "Chankanai-117",
      "Chavakachcheri-095",
      "Chenkalady-098",
      "Chilaw-015",
      "Chunnakam-166",
      "Cinnamon Gardens-032",
      "City Office-001",
      "Colombo Fort-030",
      "Colombo Gold Centre-144",
      "Dam Street-069",
      "Dambulla-103",
      "Dankotuwa-161",
      "Deal Place-156",
      "Dehiattakandiya-029",
      "Dehiwala-014",
      "Dummalasooriya-111",
      "Embilipitiya-045",
      "Eppawala-138",
      "Galenbidunuwewa-113",
      "Galle-016",
      "Gampaha-011",
      "Gampola-025",
      "Ganemulla-060",
      "Godagama-112",
      "Gothatuwa-123",
      "Grandpass-022",
      "Hambantota-081",
      "Hasalaka-155",
      "Hatton-039",
      "Havelock Town-083",
      "Head Office-999",
      "Hikkaduwa-140",
      "Hingurakgoda-051",
      "Homagama-043",
      "Horana-023",
      "Ingiriya-120",
      "Ja-Ela-027",
      "Jaffna-085",
      "Kadawatha-028",
      "Kaduruwela-102",
      "Kalawanchikudy-130",
      "Kalmunai-097",
      "Kalpitiya-147",
      "Kalubowila-042",
      "Kalutara-036",
      "Kamburupitiya-146",
      "Kandana-168",
      "Kandy-017",
      "Kanthale-115",
      "Karapitiya-164",
      "Kataragama-148",
      "Kaththankudy-074",
      "Katugastota-149",
      "Katunayaka-031",
      "Katuneriya-055",
      "Kegalle-010",
      "Kekirawa-077",
      "Kelaniya-143",
      "Kilinochchi-093",
      "Kiribathgoda-006",
      "Kirindiwela-126",
      "Kirulapone-122",
      "Kochchikade-058",
      "Koggala-056",
      "Kollupitiya-008",
      "Kotagala Talawakale-061",
      "Kotahena-118",
      "Kotiyakumbura-136",
      "Kottawa-033",
      "Kuliyapitiya-044",
      "Kurunegala-018",
      "Maharagama-004",
      "Mahiyanganaya-107",
      "Malabe-067",
      "Manampitiya-053",
      "Manipay-131",
      "Mannar-094",
      "Maradana-047",
      "Marandagahamula-084",
      "Matale-038",
      "Matara-002",
      "Matara Bazzar-165",
      "Mathugama-066",
      "Mawanella-048",
      "Mawathagama-109",
      "Medawachchiya-132",
      "Meegoda-089",
      "Millenium-086",
      "Minuwangoda-124",
      "Mirigama-078",
      "Monaragala-104",
      "Moratumulla-125",
      "Moratuwa-009",
      "Mount Lavinia-003",
      "Mullativu-096",
      "Mutwal-167",
      "Narammala-106",
      "Nawala-052",
      "Nawalapitiya-076",
      "Negombo-013",
      "Nelliady-092",
      "Nittambuwa-087",
      "Nochchiyagama-133",
      "Nugegoda-012",
      "Nuwara Eliya-019",
      "Old Moor Street-050",
      "Padaviya-154",
      "Pallekelle-134",
      "Panadura-005",
      "Pannala-162",
      "Pelmadulla.-090",
      "Peradeniya-157",
      "Pettah-064",
      "Pilimathalawa-158",
      "Piliyandala-099",
      "Pitakotte-114",
      "Polonnaruwa-159",
      "Pothuvil-151",
      "Pussellawa-110",
      "Puttalam-049",
      "Raddolugama-062",
      "Ranpokunugama-128",
      "Ratnapura-007",
      "Retail Remittance Center-998",
      "Rideegama-141",
      "Ruwanwella-080",
      "Samanthurai-152",
      "Sarikkamulla-040",
      "Seylan Bank Head Office-000",
      "Seylan Card Centre (SCC)-997",
      "Siyambalanduwa-153",
      "Soysapura-079",
      "Tissamaharama-037",
      "Trincomalee-088",
      "Udappu-119",
      "Vavuniya-072",
      "Veyangoda-108",
      "Wadduwa-142",
      "Warakapola-070",
      "Wattala-071",
      "Welimada-057",
      "Weliveriya-063",
      "Wellawatte-068",
      "Wennappuwa-160",
      "Wijerama-135",
      "Yakkala-035",
      "Yatiyantota-127",
    ],
    "7038-Standard Chartered Bank": [
      "Colpetty-002",
      "Head Office-001",
      "Head Office-999",
      "Kiribathgoda-004",
      "Kirullapone-005",
      "Moratuwa-006",
      "Negombo-012",
      "Rajagiriya-007",
      "Union Place-011",
      "Wattala-014",
      "Wellawatte-003",
    ],
    "7144-State Bank of India": [
      " Head Office-000",
      "Head Office-001",
      "Head Office-999",
      "Jaffna-003",
      "Kandy-002",
      "Kohuwala-032",
    ],
    "7764-State Mortgage & Investment Bank": [
      "Ambalantota-014",
      "Ampara-017",
      "Anuradhapura-024",
      "Badulla-022",
      "Battaramulla-010",
      "Batticaloa-015",
      "Chilaw-008",
      "Galle-005",
      "Gampaha-004",
      "Hatton-021",
      "Head Office City-001",
      "Horana-013",
      "Jaffna-016",
      "Kaduruwela-019",
      "Kandy-002",
      "Kegalle-012",
      "Kiribathgoda-011",
      "Kurunegala-006",
      "Matale-025",
      "Matara-009",
      "Matugama-007",
      "Monaragala-023",
      "Ratnapura-018",
      "SMIB Finance Department-003",
      "Vavuniya-020",
    ],
    "7302-Union Bank of Colombo PLC": [
      "Akuressa-063",
      "Ambalangoda-035",
      "Ambalanthota-049",
      "Angunakolapelessa-041",
      "Anuradhapura-031",
      "Atchuvely-022",
      "Attidiya-065",
      "Badulla-033",
      "Balangoda-051",
      "Batticaloa-025",
      "Chilaw-036",
      "Chunnakkam-021",
      "Colpetty-002",
      "Dhambulla-032",
      "Elpitiya-060",
      "Embilipitiya-044",
      "Galle-027",
      "Gampaha-024",
      "Gampola-043",
      "Ganemulla-059",
      "Head Office Branch-008",
      "Horana-034",
      "Horowpathana-048",
      "Ibbagamuwa-055",
      "Ja ela-014",
      "Jaffna-018",
      "Kadawatha-029",
      "Kandy-003",
      "Kebithigollewa-042",
      "Kegalle-045",
      "Kekirawa-047",
      "Kohuwala-066",
      "Kotahena-012",
      "Kuliyapitiya-056",
      "Kurunegala-009",
      "Maharagama-052",
      "Mannar-019",
      "Marawila-037",
      "Matara-011",
      "Mathugama-053",
      "Medawachchiya-061",
      "Minuwangoda-050",
      "Moneragala-058",
      "Moratuwa-016",
      "Narammala-039",
      "Nawala-004",
      "Nawalapitiya-054",
      "Negambo-010",
      "Neugegoda-015",
      "New Borella-067",
      "Old Moor Street-007",
      "Panadura-038",
      "Pelawatte-040",
      "Pettah-006",
      "Pilimathalawa-057",
      "Piliyandala-028",
      "Rajagiriaya-064",
      "Ratmalana-062",
      "Ratnapura-030",
      "Trincomalee-026",
      "UB Corporate-997",
      "UB Main Office-001",
      "Vavuniya-020",
      "Warakapola-046",
      "Wattala-023",
      "Wellawatte-005",
      "Wennappuwa-017",
    ],
    "7816-Vallibel Finance PLC": ["Head Office-001"],
  })

  export const bankValue = () => ({
    "7038-Standard Chartered Bank": [
      "Colpetty-002",
      "Head Office-001",
      "Head Office-999",
      "Kiribathgoda-004",
      "Kirullapone-005",
      "Moratuwa-006",
      "Negombo-012",
      "Rajagiriya-007",
      "Union Place-011",
      "Wattala-014",
      "Wellawatte-003",
    ],
    "7144-State Bank of India": [
      " Head Office-000",
      "Head Office-001",
      "Head Office-999",
      "Jaffna-003",
      "Kandy-002",
      "Kohuwala-032",
    ],
  })
  